// Traduction anglaise des autres espaces (administration, enseignants, comptabilité, CM,
// secrétariat, Brand Ambassadors, parents, générateur d’épreuves, accueil et connexion).
// Clé : texte français affiché ; valeur : texte anglais. Complète i18n/en.js.
const EN_ESPACES = {
  "Inscription, connexion et code manuel": "Sign-up, login and textbook code",
  "Créer un compte, se connecter et activer un manuel sans confondre les différents codes.": "Create an account, log in and activate a textbook without mixing up the different codes.",
  "Choisissez Inscription et renseignez les champs obligatoires.": "Choose Sign up and fill in the required fields.",
  "À la connexion, utilisez vos identifiants personnels.": "When logging in, use your personal credentials.",
  "Le code manuel active le manuel auquel il est associé. Un code de parrainage est facultatif et distinct.": "The textbook code activates the textbook it belongs to. A referral code is optional and separate.",
  "Abonnements et accès aux contenus": "Subscriptions and access to content",
  "Comprendre pourquoi un contenu est disponible, verrouillé ou arrivé à expiration.": "Understand why content is available, locked or expired.",
  "L’accès dépend du manuel et de la période d’abonnement affichés dans votre compte.": "Access depends on the textbook and the subscription period shown in your account.",
  "Actualisez votre compte après une activation effectuée sur un autre support.": "Refresh your account after an activation made on another device.",
  "Android Play permet de consulter et d’actualiser l’état de l’accès, sans achat direct dans l’application.": "Android Play lets you view and refresh your access status, with no direct purchase in the app.",
  "Recherche": "Search",
  "Retrouver un contenu par nom, fragment de nom ou code.": "Find content by name, part of a name or code.",
  "Saisissez au moins une partie du nom ou le code connu.": "Enter at least part of the name or the known code.",
  "La casse et les accents n’empêchent pas la recherche.": "Case and accents do not prevent the search.",
  "Le type de contenu est indiqué. Seuls les résultats auxquels votre compte a droit sont affichés.": "The content type is shown. Only results your account is entitled to are displayed.",
  "Générateur d’épreuves": "Test generator",
  "Prévisualiser, choisir le palier et reprendre une génération sans double débit.": "Preview, choose the tier and resume a generation without double charging.",
  "Complétez les champs obligatoires puis lancez la prévisualisation.": "Fill in the required fields, then start the preview.",
  "Après l’aperçu, choisissez le palier proposé. Toute modification des paramètres invalide l’aperçu.": "After the preview, choose the proposed tier. Any change to the settings invalidates the preview.",
  "Si une correction Premium manque, l’application vous avertit avant confirmation.": "If a Premium correction is missing, the app warns you before confirmation.",
  "En cas d’échec, conservez la référence affichée et utilisez Réessayer. Aucun paiement réel n’est requis pour la démonstration.": "If it fails, keep the reference shown and use Try again. No real payment is required for the demonstration.",
  "Emploi du temps, tâches et rappels": "Timetable, tasks and reminders",
  "Organiser les créneaux et recevoir un rappel lorsque l’application est ouverte.": "Organise slots and receive a reminder while the app is open.",
  "Une note peut être enregistrée sans échéance ni rappel.": "A note can be saved without a deadline or reminder.",
  "Pour un rappel, ajoutez une échéance et autorisez les notifications si le système le demande.": "For a reminder, add a deadline and allow notifications if the system asks.",
  "Modifier, terminer ou supprimer une tâche annule son ancien rappel.": "Editing, completing or deleting a task cancels its previous reminder.",
  "Les rappels application fermée ne sont pas encore disponibles.": "Reminders while the app is closed are not available yet.",
  "Profils enseignants et espace parents": "Teacher profiles and parent space",
  "Rechercher un profil approuvé et transmettre une demande encadrée à l’administration.": "Find an approved profile and send a supervised request to the administration.",
  "L’annuaire public contient uniquement les profils approuvés.": "The public directory only contains approved profiles.",
  "Un parent peut filtrer par matière, classe, ville et modalité.": "A parent can filter by subject, class, city and format.",
  "La demande conserve le professeur choisi et ouvre un échange privé avec l’administration.": "The request keeps the chosen teacher and opens a private exchange with the administration.",
  "Consulter un profil ne permet pas de publier un avis ; une prestation éligible doit d’abord être confirmée.": "Viewing a profile does not allow posting a review; an eligible service must first be confirmed.",
  "Parrainage": "Referral",
  "Partager le code personnel et suivre les parrainages sans exposer les données du filleul.": "Share your personal code and follow referrals without exposing the referee's data.",
  "Le code de parrainage est distinct du code manuel et reste facultatif à l’inscription.": "The referral code is separate from the textbook code and is optional at sign-up.",
  "Le suivi indique les parrainages en attente ou validés et la durée attribuée.": "Tracking shows pending or validated referrals and the time granted.",
  "Le taux prévu est 10 % des jours payés et confirmés au bénéfice du parrain, fractions conservées en heures, minutes et secondes.": "The planned rate is 10% of the paid and confirmed days for the referrer, with fractions kept in hours, minutes and seconds.",
  "La campagne reste désactivée tant que ses conditions d’éligibilité ne sont pas validées.": "The campaign remains disabled until its eligibility conditions are validated.",
  "Le navigateur système Android n'est pas disponible.": "The Android system browser is not available.",
  "Suivez votre progression": "Track your progress",
  "Un tableau de bord clair avec votre avancement, vos scores et les prochaines sessions en direct.": "A clear dashboard with your progress, your scores and the next live sessions.",
  "Toutes vos leçons, organisées": "All your lessons, organised",
  "Chaque leçon est classée par module, prête à être étudiée à votre rythme.": "Each lesson is sorted by module, ready to be studied at your own pace.",
  "Testez-vous avec des QCM": "Test yourself with quizzes",
  "Des quiz interactifs pour vérifier vos acquis et progresser étape par étape.": "Interactive quizzes to check what you have learned and progress step by step.",
  "Des exercices corrigés": "Corrected exercises",
  "Entraînez-vous sur des exercices variés, avec correction détaillée à l'appui.": "Practise on a variety of exercises, with detailed corrections.",
  "Une banque d'épreuves réelles": "A bank of real exams",
  "Accédez à des épreuves déjà tombées, téléchargeables en PDF pour réviser sereinement.": "Access past exam papers, downloadable as PDF so you can revise with peace of mind.",
  "Rendez vos devoirs en ligne": "Hand in your homework online",
  "Un clavier mathématique intégré vous permet de saisir formules et équations facilement.": "A built-in maths keyboard lets you type formulas and equations easily.",
  "Suivez tous vos résultats": "Track all your results",
  "QCM, exercices, devoirs, évaluations : retrouvez toutes vos performances au même endroit.": "Quizzes, exercises, homework, assessments: find all your results in one place.",
  "Un professeur à portée de message": "A teacher just a message away",
  "Faites-vous assister par vos enseignants dès que vous rencontrez une difficulté.": "Get help from your teachers as soon as you run into a difficulty.",
  "Échangez en groupe": "Work together in groups",
  "Rejoignez les groupes de votre classe pour apprendre et progresser ensemble.": "Join your class groups to learn and progress together.",
  "Revivez les sessions en direct": "Relive the live sessions",
  "Les cours en direct restent disponibles en replay, à tout moment.": "Live lessons remain available as replays, at any time.",
  "Un générateur d'épreuves pour les enseignants": "A test generator for teachers",
  "Les enseignants créent leurs épreuves personnalisées en quelques clics, avec correspondance en temps réel.": "Teachers create their own custom tests in a few clicks, with real-time matching.",
  "Remonter en haut de la page": "Back to top",
  "1 mois offert": "1 month free",
  "Bienvenue dans Quick Learning !": "Welcome to Quick Learning!",
  "Votre manuel est activé et nous sommes heureux de vous offrir": "Your textbook is activated and we are happy to offer you",
  "30 jours d’abonnement": "30 days of subscription",
  "jusqu’au": "until",
  "pendant un mois": "for one month",
  "Commencer à apprendre": "Start learning",
  "Compte actualisé.": "Account refreshed.",
  "Actualisation impossible. Vérifiez votre connexion puis réessayez.": "Refresh failed. Check your connection and try again.",
  "Abonnement inactif": "Subscription inactive",
  "Votre abonnement ne permet plus d’accéder à ce contenu. Si votre compte a été renouvelé en dehors de cette application, appuyez sur Actualiser mon compte.": "Your subscription no longer gives access to this content. If your account was renewed outside this app, tap Refresh my account.",
  "Expiration :": "Expiry:",
  "Formule :": "Plan:",
  "L’application Android permet de consulter les contenus associés à un compte actif. Aucun achat, renouvellement ou paiement n’est proposé dans l’application.": "The Android app lets you view content linked to an active account. No purchase, renewal or payment is offered in the app.",
  "Actualisation…": "Refreshing…",
  "Se déconnecter": "Log out",
  "Veuillez sélectionner votre classe avant de continuer.": "Please select your class before continuing.",
  "Le paiement a été initialisé, mais la page CinetPay n’a pas pu être ouverte. Utilisez le bouton Réouvrir la page CinetPay.": "The payment has started, but the CinetPay page could not be opened. Use the Reopen the CinetPay page button.",
  "Abonnement expiré": "Subscription expired",
  "Votre accès a expiré le": "Your access expired on",
  "Accès restreint": "Restricted access",
  "! Souscrivez à un forfait pour accéder à la plateforme.": "! Subscribe to a plan to access the platform.",
  "Accès en cours d'activation…": "Access being activated…",
  "Cette page se mettra à jour automatiquement après confirmation.": "This page will update automatically after confirmation.",
  "Votre classe": "Your class",
  "— Sélectionnez votre classe —": "— Select your class —",
  "Obligatoire — votre classe détermine les manuels accessibles.": "Required — your class determines which textbooks you can access.",
  "Cours vidéo clairs et détaillés": "Clear and detailed video lessons",
  "Chaque leçon est expliquée en vidéo par des enseignants expérimentés. Les concepts les plus difficiles — démonstrations de Maths, expériences de Physique, réactions de Chimie — sont illustrés étape par étape pour une compréhension durable.": "Every lesson is explained on video by experienced teachers. The hardest concepts — maths proofs, physics experiments, chemical reactions — are illustrated step by step for lasting understanding.",
  "Vidéos HD": "HD videos",
  "Exercices corrigés pas à pas": "Step-by-step corrected exercises",
  "Des centaines d'exercices tirés des programmes officiels, avec des corrections détaillées. Chaque étape est expliquée pour que tu comprennes non seulement la réponse, mais aussi le raisonnement — exactement ce que demandent les correcteurs au BEPC, au Probatoire et au Baccalauréat.": "Hundreds of exercises from the official curricula, with detailed corrections. Each step is explained so you understand not only the answer but also the reasoning — exactly what examiners expect at the BEPC, Probatoire and Baccalauréat.",
  "+500 exercices": "500+ exercises",
  "QCM interactifs avec corrigés": "Interactive quizzes with answers",
  "Teste tes connaissances avec des QCM chronométrés sur chaque chapitre. Après chaque réponse, un corrigé immédiat t'explique pourquoi tu as juste ou faux — un entraînement idéal pour les épreuves à choix multiples des examens officiels.": "Test your knowledge with timed quizzes on every chapter. After each answer, an instant explanation tells you why you were right or wrong — ideal practice for the multiple-choice papers of official exams.",
  "Auto-évaluation": "Self-assessment",
  "Suivi de progression personnalisé": "Personalised progress tracking",
  "Ton tableau de bord affiche ta progression chapitre par chapitre : leçons vues, exercices réussis, scores aux QCM, temps passé. Tu identifies tes lacunes et tu sais exactement où concentrer tes efforts pour progresser efficacement.": "Your dashboard shows your progress chapter by chapter: lessons viewed, exercises passed, quiz scores, time spent. You spot your gaps and know exactly where to focus your efforts.",
  "Messagerie avec les enseignants": "Messaging with teachers",
  "Tu bloques sur un exercice ou une notion ? Envoie un message directement à ton enseignant depuis la plateforme. Tu reçois une réponse claire et rapide sans avoir à attendre la prochaine heure de cours — un vrai soutien scolaire à portée de main.": "Stuck on an exercise or a concept? Send a message straight to your teacher from the platform. You get a clear, quick answer without waiting for the next lesson — real tutoring at your fingertips.",
  "Support direct": "Direct support",
  "Manuel numérique enrichi": "Enhanced digital textbook",
  "Retrouve l'intégralité de ton manuel en version numérique, organisée en modules et leçons. Le contenu physique que tu connais déjà est enrichi de vidéos, exercices et ressources complémentaires — rendant ton manuel bien plus puissant qu'en version papier.": "Find your whole textbook in digital form, organised into modules and lessons. The printed content you already know is enriched with videos, exercises and extra resources — making your textbook far more powerful than the paper version.",
  "Cours complets": "Complete lessons",
  "Préparation ciblée aux examens": "Targeted exam preparation",
  "Des évaluations types BEPC, Probatoire et Baccalauréat, des sujets des années précédentes et des révisions guidées par matière. La plateforme t'aide à t'entraîner dans les conditions réelles de chaque examen pour arriver confiant et préparé le jour J.": "BEPC, Probatoire and Baccalauréat-style assessments, past papers and guided revision by subject. The platform helps you practise in real exam conditions so you arrive confident and prepared on the day.",
  "BEPC · Probatoire · BAC": "BEPC · Probatoire · BAC",
  "Accessible partout, à tout moment": "Available anywhere, anytime",
  "Quick Learning fonctionne sur téléphone, tablette et ordinateur. Que tu sois chez toi, au collège ou en déplacement, tu accèdes à tous tes cours et exercices 24h/24, 7j/7 — sans dépendre d'un horaire ou d'un lieu fixe.": "Quick Learning works on phone, tablet and computer. Whether you are at home, at school or on the move, you can access all your lessons and exercises 24/7 — without depending on a timetable or a fixed place.",
  "Génération automatique d'épreuves": "Automatic test generation",
  "Les enseignants créent des épreuves personnalisées en quelques clics : choix des modules et des leçons, niveau de difficulté, mise en page — le sujet et son corrigé sont générés automatiquement, prêts à imprimer ou à partager.": "Teachers create custom tests in a few clicks: choice of modules and lessons, difficulty level, layout — the paper and its answer key are generated automatically, ready to print or share.",
  "Pour les enseignants": "For teachers",
  "Exercices résolus de différents modules": "Solved exercises from various modules",
  "Leçons bien expliquées": "Well-explained lessons",
  "De contenu vidéo disponible": "Of video content available",
  "Souscrivez à partir de 100 F/jour": "Subscribe from 100 F/day",
  "Impossible de se connecter.": "Unable to log in.",
  "Erreur d'envoi. Vérifiez votre connexion.": "Sending error. Check your connection.",
  "Lien expiré ou invalide. Refaites une demande.": "Link expired or invalid. Please request a new one.",
  "Mot de passe insuffisant. Vous devez avoir : 8 caractères minimum, une majuscule, un chiffre et un caractère spécial (@, #, !, …).": "Password too weak. You need: at least 8 characters, one capital letter, one digit and one special character (@, #, !, …).",
  "Création de votre compte… veuillez patienter.": "Creating your account… please wait.",
  "Préparation de votre espace… veuillez patienter.": "Preparing your space… please wait.",
  "Impossible de s'inscrire. Vérifiez votre connexion et réessayez.": "Unable to sign up. Check your connection and try again.",
  "Espace enseignant": "Teacher space",
  "L’espace enseignant n’est pas disponible dans l’application Android. Veuillez utiliser l’application Windows ou le site web Quick Learning.": "The teacher space is not available in the Android app. Please use the Windows app or the Quick Learning website.",
  "Impossible d’ouvrir le navigateur système.": "Unable to open the system browser.",
  "Ouvrir le site web": "Open the website",
  "Retour à la connexion": "Back to login",
  "Ouverture de votre espace…": "Opening your space…",
  "Quick Learning — accueil": "Quick Learning — home",
  "Quick Learning — Apprendre n'a jamais été aussi aisé": "Quick Learning — Learning has never been so easy",
  "Accueil": "Home",
  "Le manuel": "The textbook",
  "Fonctionnalités": "Features",
  "Tarifs": "Pricing",
  "À propos": "About",
  "Contact": "Contact",
  "Télécharger l’application": "Download the app",
  "Télécharger Quick Learning pour Windows": "Download Quick Learning for Windows",
  "Télécharger Quick Learning pour Mac": "Download Quick Learning for Mac",
  "Télécharger Quick Learning pour Android": "Download Quick Learning for Android",
  "Aide": "Help",
  "Mon espace parent": "My parent space",
  "Se connecter": "Log in",
  "Activer mon manuel": "Activate my textbook",
  "Revenir à l'accueil": "Back to home",
  "Navigation principale": "Main navigation",
  "Découverte": "Discover",
  "Fermer le menu": "Close the menu",
  "Ouvrir le menu": "Open the menu",
  "LE MANUEL PAPIER + LE NUMÉRIQUE": "THE PAPER TEXTBOOK + DIGITAL",
  "Comprends tes cours.": "Understand your lessons.",
  "Entraîne-toi.": "Practise.",
  "Progresse.": "Progress.",
  "Des manuels, des exercices et des vidéos de correction pour avancer à ton rythme.": "Textbooks, exercises and video corrections to move forward at your own pace.",
  "Découvrir Quick Learning": "Discover Quick Learning",
  "Corrections vidéo": "Video corrections",
  "Lives vidéo": "Live video lessons",
  "Épreuves des établissements": "School exam papers",
  "Assistance par des enseignants": "Help from teachers",
  "Enseignants : préparez vos épreuves avec Quick Learning": "Teachers: prepare your tests with Quick Learning",
  "Découvrir le générateur": "Discover the generator",
  "DÉCOUVREZ LA PLATEFORME": "DISCOVER THE PLATFORM",
  "Comment fonctionne Quick Learning ?": "How does Quick Learning work?",
  "Une courte vidéo pour découvrir les manuels numériques, les exercices, et le générateur d'épreuves pour les enseignants.": "A short video to discover the digital textbooks, the exercises and the test generator for teachers.",
  "Vidéo de démonstration bientôt disponible": "Demo video coming soon",
  "Vidéo de démonstration": "Demo video",
  "Nos Manuels disponibles": "Our available textbooks",
  "Choisissez votre manuel, activez votre code et accédez à tout le contenu numérique.": "Choose your textbook, activate your code and access all the digital content.",
  "Aucun manuel disponible pour le moment.": "No textbook available yet.",
  "25 chapitres": "25 chapters",
  "+10h vidéos": "10+ h of videos",
  "Voir moins": "See less",
  "Voir tous les manuels": "See all textbooks",
  "autres manuels disponibles": "other textbooks available",
  "FONCTIONNALITÉS": "FEATURES",
  "Tout ce qu'il faut pour réussir": "Everything you need to succeed",
  "Quick Learning réunit en un seul endroit tous les outils dont un élève camerounais a besoin pour exceller aux examens officiels.": "Quick Learning brings together in one place all the tools a Cameroonian student needs to excel in official exams.",
  "Découvrir la plateforme": "Discover the platform",
  "TARIFS ACCESSIBLES": "AFFORDABLE PRICING",
  "Investissez dans votre réussite scolaire": "Invest in your success at school",
  "Pour": "For",
  "moins de 100 FCFA par jour": "less than 100 FCFA a day",
  ", accédez à l'intégralité des cours, vidéos, QCM et exercices de votre manuel — disponibles": ", get access to all the lessons, videos, quizzes and exercises of your textbook — available",
  ", même sans connexion internet stable.": ", even without a stable internet connection.",
  "Vidéos explicatives illimitées": "Unlimited explanatory videos",
  "QCM & exercices corrigés": "Quizzes & corrected exercises",
  "Suivi de ta progression": "Progress tracking",
  "Activation immédiate": "Instant activation",
  "Paiement 100 % sécurisé": "100% secure payment",
  "⭐ Populaire": "⭐ Popular",
  "Commencer →": "Start →",
  "MÉTHODES DE PAIEMENT ACCEPTÉES": "ACCEPTED PAYMENT METHODS",
  "Activation immédiate après paiement": "Instant activation after payment",
  "Aucun engagement, résiliable à tout moment": "No commitment, cancel at any time",
  "Transaction sécurisée via CinetPay": "Secure transaction via CinetPay",
  "\"Des milliers d'élèves camerounais font déjà confiance à Quick Learning pour exceller aux examens. Et toi ?\"": "\"Thousands of Cameroonian students already trust Quick Learning to excel in their exams. What about you?\"",
  "Activer mon accès maintenant": "Activate my access now",
  "Retrouvez les meilleurs professeurs pour accompagner vos enfants": "Find the best teachers to support your children",
  "Cliquez ici": "Click here",
  "NOTRE HISTOIRE": "OUR STORY",
  "Une vision née de l'excellence": "A vision born of excellence",
  "Quick Learning est la rencontre entre l'ingénierie de haut niveau et la passion de transmettre le savoir.": "Quick Learning is where high-level engineering meets a passion for sharing knowledge.",
  "Fondateur & CEO — Quick Learning": "Founder & CEO — Quick Learning",
  "Ingénieur Aéronautique · Docteur en formation · Prof. de Maths & Physique": "Aeronautical engineer · PhD candidate · Maths & Physics teacher",
  "Né en": "Born in",
  "1997 au Cameroun": "1997 in Cameroon",
  "a toujours cru que l'excellence académique ne devrait jamais être une question de moyens. Diplômé ingénieur en": "has always believed that academic excellence should never depend on means. A graduate engineer in",
  "aéronautique de l'École AEROSUP de Casablanca": "aeronautics from AEROSUP School in Casablanca",
  "— l'une des meilleures écoles d'ingénierie du continent africain — et titulaire d'un": "— one of the best engineering schools on the African continent — and holder of a",
  "Master de l'Université de Yaoundé I": "Master's degree from the University of Yaoundé I",
  "(2019), il a eu l'honneur de collaborer avec des géants mondiaux tels que": "(2019), he has had the honour of working with global giants such as",
  "Malgré un parcours international brillant, son regard est resté tourné vers une seule réalité :": "Despite a brilliant international career, his gaze has remained fixed on one reality:",
  "des milliers d'élèves camerounais échouent chaque année aux examens officiels": "thousands of Cameroonian students fail official exams every year",
  ", non par manque d'intelligence, mais par manque d'accès à des ressources pédagogiques de qualité.": ", not for lack of intelligence, but for lack of access to quality learning resources.",
  "C'est cette conviction qui a donné naissance à": "It is this conviction that gave birth to",
  "Quick Learning en 2026": "Quick Learning in 2026",
  "— une plateforme bâtie par un enseignant, pour des élèves, avec la rigueur d'un ingénieur.": "— a platform built by a teacher, for students, with an engineer's rigour.",
  "\"Je voulais qu'un élève de Maroua, de Bafoussam ou de Bertoua ait accès aux mêmes outils qu'un élève de Yaoundé ou Douala. Quick Learning, c'est l'égalité des chances mise en pratique.\"": "\"I wanted a student in Maroua, Bafoussam or Bertoua to have access to the same tools as a student in Yaoundé or Douala. Quick Learning is equal opportunity put into practice.\"",
  "— Ing. Borice FOTSO NOUMSI, Fondateur": "— Eng. Borice FOTSO NOUMSI, Founder",
  "Notre mission": "Our mission",
  "Démocratiser l'accès à une éducation de qualité au Cameroun en mettant la technologie au service de la réussite scolaire —": "To democratise access to quality education in Cameroon by putting technology at the service of academic success —",
  "pour chaque élève, partout dans le pays.": "for every student, everywhere in the country.",
  "Excellence": "Excellence",
  "Des contenus conçus par des experts, alignés sur les programmes officiels camerounais.": "Content designed by experts, aligned with the official Cameroonian curricula.",
  "Accessibilité": "Accessibility",
  "Des tarifs adaptés à la réalité économique des familles camerounaises.": "Prices suited to the economic reality of Cameroonian families.",
  "Résultats": "Results",
  "Un accompagnement personnalisé pour transformer chaque élève en lauréat.": "Personalised support to turn every student into a laureate.",
  "Confiance": "Trust",
  "Une plateforme sécurisée, fiable, disponible à tout moment, même offline.": "A secure, reliable platform, available at all times, even offline.",
  "Nos ambitions pour 2026–2027": "Our ambitions for 2026–2027",
  "élèves sur la plateforme": "students on the platform",
  "de taux de réussite aux examens officiels": "pass rate in official exams",
  "matières disponibles (Maths, Physique, Chimie…)": "subjects available (Maths, Physics, Chemistry…)",
  "accès aux contenus, partout au Cameroun": "access to content, everywhere in Cameroon",
  "ILS NOUS FONT CONFIANCE": "THEY TRUST US",
  "Ce que disent nos élèves et nos enseignants": "What our students and teachers say",
  "Des résultats concrets, des mots sincères.": "Real results, sincere words.",
  "\"Avant Quick Learning, je passais des heures à relire mes cours sans vraiment tout saisir. Grâce aux vidéos de la plateforme, chaque notion est expliquée avec clarté et des exemples concrets — même les chapitres de Physique que je trouvais impossibles ! Le manuel était déjà un bon outil, mais combiné à la plateforme, c'est une expérience complètement différente. En un seul trimestre, j'ai gagné": "\"Before Quick Learning, I spent hours re-reading my lessons without really understanding everything. Thanks to the platform's videos, every concept is explained clearly with concrete examples — even the physics chapters I found impossible! The textbook was already a good tool, but combined with the platform it is a completely different experience. In a single term, I gained",
  "+5 points en Physique": "+5 points in Physics",
  "+4 points en Maths": "+4 points in Maths",
  "Collège Saint Louise · Élève en classe de Terminale": "Collège Saint Louise · Final-year student",
  "\"Quick Learning a totalement changé ma façon de travailler. Les cours sont bien structurés, les vidéos sont simples à suivre et les explications restent en mémoire bien plus longtemps qu'un simple cours écrit. J'ai nettement amélioré mes résultats en": "\"Quick Learning has completely changed the way I work. The lessons are well structured, the videos are easy to follow and the explanations stay in memory much longer than a simple written lesson. I have clearly improved my results in",
  "Mathématiques, Chimie et SVT": "Maths, Chemistry and Biology",
  "un avantage décisif pour le BAC": "a decisive advantage for the BAC",
  "Collège Christ Roi de Tsinga · Élève en classe de Première": "Collège Christ Roi de Tsinga · Lower sixth student",
  "\"Le générateur d'épreuves m'a fait gagner un temps précieux. Je choisis les modules et les leçons, le niveau de difficulté, et l'épreuve — avec son corrigé — est prête en quelques minutes, alors que la préparation d'un devoir me prenait auparavant des heures. La mise en page est propre et directement imprimable. C'est devenu un": "\"The test generator has saved me precious time. I choose the modules and lessons, the difficulty level, and the test — with its answer key — is ready in a few minutes, whereas preparing a test used to take me hours. The layout is clean and ready to print. It has become an",
  "outil indispensable": "essential tool",
  "dans ma pratique de tous les jours.\"": "in my everyday practice.\"",
  "Enseignant de Mathématiques": "Mathematics teacher",
  "\"Ce que j'apprécie le plus, c'est la fiabilité des épreuves générées : les exercices correspondent vraiment au programme officiel, et je peux varier les sujets d'une classe à l'autre sans effort supplémentaire. Mes élèves progressent également grâce au manuel numérique, qu'ils consultent en dehors des heures de cours. Une plateforme": "\"What I appreciate most is the reliability of the generated tests: the exercises really match the official curriculum, and I can vary the papers from one class to another without extra effort. My students also progress thanks to the digital textbook, which they use outside class hours. A platform",
  "pensée pour les réalités du terrain": "designed for real-world conditions",
  "Enseignante de Français": "French teacher",
  "Note moyenne · Nos élèves adorent la plateforme": "Average rating · Our students love the platform",
  "Une question ? Contactez-nous": "A question? Contact us",
  "Notre équipe est disponible pour vous accompagner dans votre démarche.": "Our team is available to support you.",
  "Cameroun (national)": "Cameroon (national)",
  "© 2026 Quick Learning — Fondé par Ing. Borice FOTSO NOUMSI · Cameroun": "© 2026 Quick Learning — Founded by Eng. Borice FOTSO NOUMSI · Cameroon",
  "Connexion": "Login",
  "Inscription": "Sign up",
  "Nom d'utilisateur": "Username",
  "Mot de passe": "Password",
  "Code manuel / Code enseignant": "Textbook code / Teacher code",
  "(non requis pour les comptables et admins)": "(not required for accountants and admins)",
  "Ex : QL-PHY-TLE-1-RRB ou QL-ENS-...": "E.g. QL-PHY-TLE-1-RRB or QL-ENS-...",
  "Pourquoi ce code ?": "Why this code?",
  "Élève :": "Student:",
  "Entrez le code imprimé dans votre": "Enter the code printed in your",
  "manuel scolaire papier": "paper school textbook",
  "(ex :": "(e.g.",
  "). Ce code prouve que vous avez accès au manuel.": "). This code proves you have access to the textbook.",
  "Entrez votre code personnel commençant par": "Enter your personal code starting with",
  ", reçu lors de votre inscription.": ", received when you signed up.",
  "Admin / Comptable / Community Manager / Secrétariat / Brand Ambassador :": "Admin / Accountant / Community Manager / Secretariat / Brand Ambassador:",
  "Laissez ce champ": "Leave this field",
  ", il ne vous concerne pas.": ", it does not concern you.",
  "Brand Ambassador — laissez ce champ vide pour vous connecter": "Brand Ambassador — leave this field empty to log in",
  "Secrétariat — laissez ce champ vide pour vous connecter": "Secretariat — leave this field empty to log in",
  "Community Manager — laissez ce champ vide pour vous connecter": "Community Manager — leave this field empty to log in",
  "Comptable — laissez ce champ vide pour vous connecter": "Accountant — leave this field empty to log in",
  "Enseignant détecté": "Teacher detected",
  "Physique": "Physics",
  "Chimie": "Chemistry",
  "Mathématiques": "Mathematics",
  "Informatique": "Computer science",
  "Terminale": "Final year (Terminale)",
  "Première": "Lower sixth (Première)",
  "Seconde": "Fifth form (Seconde)",
  "Troisième": "Fourth form (Troisième)",
  "détecté(s)": "detected",
  "Pas encore de compte ?": "No account yet?",
  "S'inscrire": "Sign up",
  "Mot de passe oublié ?": "Forgot your password?",
  "Email envoyé !": "Email sent!",
  "Si cet email est enregistré, vous recevrez un lien de réinitialisation dans quelques minutes. Vérifiez vos spams.": "If this email is registered, you will receive a reset link within a few minutes. Check your spam folder.",
  "Entrez votre adresse email. Vous recevrez un lien pour créer un nouveau mot de passe.": "Enter your email address. You will receive a link to create a new password.",
  "votre@email.com": "your@email.com",
  "Envoi en cours...": "Sending...",
  "Envoyer le lien": "Send the link",
  "Mot de passe modifié !": "Password changed!",
  "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.": "You can now log in with your new password.",
  "Choisissez un nouveau mot de passe pour votre compte.": "Choose a new password for your account.",
  "Minimum 8 caractères": "At least 8 characters",
  "Confirmer le mot de passe": "Confirm the password",
  "Répétez le mot de passe": "Repeat the password",
  "Enregistrement...": "Saving...",
  "Réinitialiser le mot de passe": "Reset the password",
  "Comment créer votre compte ?": "How do I create my account?",
  "Remplissez vos informations personnelles (nom, école, classe).": "Fill in your personal details (name, school, class).",
  "Entrez le": "Enter the",
  "code d'accès": "access code",
  "fourni par votre école ou qui se trouve à l'intérieur de la couverture de votre": "provided by your school or found inside the cover of your",
  "manuel papier": "paper textbook",
  "Créez un identifiant et un mot de passe pour vous connecter.": "Create a username and a password to log in.",
  "Ajouter une photo (optionnel)": "Add a photo (optional)",
  "Optionnel. Si vous ajoutez une photo, elle sera visible sur votre profil pour vous identifier plus facilement.": "Optional. If you add a photo, it will be visible on your profile so you are easier to identify.",
  "Ex : Boris Nguema": "E.g. Boris Nguema",
  "Entrez votre prénom suivi de votre nom de famille, exactement comme ils apparaissent dans votre carnet scolaire. Exemple :": "Enter your first name followed by your surname, exactly as they appear in your school record. Example:",
  "École": "School",
  "Ex : Lycée de Yaoundé": "E.g. Lycée de Yaoundé",
  "Écrivez le nom complet de votre établissement scolaire. Exemple :": "Write the full name of your school. Example:",
  "Je suis enseignant (générateur d'épreuves)": "I am a teacher (test generator)",
  "✅ Mode enseignant activé. Finalisez l'inscription — votre code d'accès personnel sera envoyé automatiquement à votre adresse email après validation.": "✅ Teacher mode activated. Complete your sign-up — your personal access code will be sent automatically to your email address after validation.",
  "Vous êtes élève ? Laissez cette case décochée. Cochez uniquement si vous êtes un professeur qui souhaite créer et générer des épreuves pour ses élèves.": "Are you a student? Leave this box unticked. Tick it only if you are a teacher who wants to create and generate tests for students.",
  "Un code d'accès unique sera généré automatiquement et envoyé à votre adresse email.": "A unique access code will be generated automatically and sent to your email address.",
  "Sélectionnez votre classe actuelle dans la liste. C'est important : cela détermine quels cours, exercices et QCM vous seront proposés sur la plateforme.": "Select your current class from the list. This is important: it determines which lessons, exercises and quizzes will be offered to you on the platform.",
  "Ex : QL-PHY-TLE-1-RRB ou QL-ENS-... ou QL-COMP-... ou QL-COMM-... ou QL-SEC-... ou QL-AMB-...": "E.g. QL-PHY-TLE-1-RRB or QL-ENS-... or QL-COMP-... or QL-COMM-... or QL-SEC-... or QL-AMB-...",
  "Où trouver votre code ?": "Where can I find my code?",
  "Le code est imprimé à l'intérieur de la couverture de votre": "The code is printed inside the cover of your",
  "(exemple :": "(example:",
  "). Si vous ne l'avez pas, demandez à votre enseignant.": "). If you don't have it, ask your teacher.",
  "Votre code commence par": "Your code starts with",
  "Brand Ambassador détecté — accès à l'espace des ventes de manuels": "Brand Ambassador detected — access to the textbook sales space",
  "Secrétariat détecté — accès à l'espace secrétariat": "Secretariat detected — access to the secretariat space",
  "Community Manager détectée — accès à l'espace communication": "Community Manager detected — access to the communication space",
  "Comptable détecté — accès comptabilité activé": "Accountant detected — accounting access enabled",
  "Code de parrainage": "Referral code",
  "(facultatif)": "(optional)",
  "Ex : QLP-12AB34CD56": "E.g. QLP-12AB34CD56",
  "Ce code personnel est distinct du code de votre manuel.": "This personal code is separate from your textbook code.",
  "C'est l'identifiant que vous utiliserez pour vous": "This is the username you will use to",
  "chaque jour. Choisissez quelque chose de simple et facile à retenir, sans espaces ni accents. Exemple :": "every day. Choose something simple and easy to remember, without spaces or accents. Example:",
  "Choisissez un identifiant unique": "Choose a unique username",
  "✓ Nom d'utilisateur disponible": "✓ Username available",
  "✗ Ce nom d'utilisateur est déjà pris.": "✗ This username is already taken.",
  "Suggestions disponibles :": "Available suggestions:",
  "Entrez une adresse email valide que vous consultez régulièrement. Elle servira à récupérer votre mot de passe en cas d'oubli.": "Enter a valid email address that you check regularly. It will be used to recover your password if you forget it.",
  "Choisissez un mot de passe": "Choose a password",
  "que vous seul connaissez. Il doit contenir au moins 8 caractères. Notez-le quelque part pour ne pas l'oublier !": "that only you know. It must contain at least 8 characters. Write it down somewhere so you don't forget it!",
  "Afficher": "Show",
  "Au moins 8 caractères": "At least 8 characters",
  "Cliquez sur un mot de passe pour l'utiliser :": "Click a password to use it:",
  "Cliquer pour utiliser ce mot de passe": "Click to use this password",
  "Notez bien votre mot de passe avant de valider.": "Write down your password before confirming.",
  "Veuillez patienter…": "Please wait…",
  "S’inscrire": "Sign up",
  "Déjà un compte ?": "Already have an account?",
  "Rappel Quick Learning": "Quick Learning reminder",
  "Informations Quick Learning": "Quick Learning information",
  "Lives, nouveaux contenus et informations liées à vos manuels": "Lives, new content and information about your textbooks",
  "Une nouvelle information est disponible.": "New information is available.",
  "⚠️ Avertissement": "⚠️ Warning",
  "⚠️ Erreur": "⚠️ Error",
  "ℹ️ Information": "ℹ️ Information",
  "✓ Succès": "✓ Success",
  "Confirmation": "Confirmation",
  "Manuels disponibles": "Available textbooks",
  "Manuel": "Textbook",
  "Sélectionnez un manuel": "Select a textbook",
  "Aucune description disponible.": "No description available.",
  "Aucun chapitre disponible pour ce manuel.": "No chapter available for this textbook.",
  "Chapitre": "Chapter",
  "Sélectionnez un manuel pour voir les chapitres.": "Select a textbook to see its chapters.",
  "Retour à Quick Learning": "Back to Quick Learning",
  "Centre d’aide ·": "Help centre ·",
  "Comment pouvons-nous vous aider ?": "How can we help you?",
  "Des réponses adaptées aux fonctions réellement disponibles sur votre plateforme.": "Answers tailored to the features actually available on your platform.",
  "Rechercher dans l’aide": "Search the help",
  "Rechercher : code manuel, rappel, abonnement…": "Search: textbook code, reminder, subscription…",
  "Aucun résultat": "No results",
  "Essayez un terme plus court ou contactez l’administration.": "Try a shorter term or contact the administration.",
  "Besoin d’une réponse personnelle ?": "Need a personal answer?",
  "Après connexion, utilisez": "After logging in, use",
  "pour échanger dans votre espace. Vous pouvez aussi écrire à l’adresse administrative existante.": "to chat in your space. You can also write to the existing administrative address.",
  "Contacter l’administration": "Contact the administration",
  "← Retour à l’application": "← Back to the app",
  "PDF téléchargé avec succès.": "PDF downloaded.",
  "Téléchargement du PDF impossible.": "Unable to download the PDF.",
  "PDF indisponible.": "PDF unavailable.",
  "Télécharger PDF": "Download PDF",
  "Vous n’avez pas la permission explicite de gérer les classements.": "You do not have explicit permission to manage rankings.",
  "Classement indisponible.": "Ranking unavailable.",
  "Création de la formule impossible.": "Unable to create the formula.",
  "Calcul impossible.": "Unable to calculate.",
  "Sélection impossible.": "Unable to select.",
  "Officialisation impossible.": "Unable to make it official.",
  "Créez une formule, calculez le classement de tous les élèves de la plateforme (aucune distinction de classe ni de série), sélectionnez jusqu’à cinq lauréats puis officialisez pour les notifier.": "Create a formula, calculate the ranking of all students on the platform (no distinction of class or stream), select up to five winners, then make it official to notify them.",
  "Nouvelle formule": "New formula",
  "Mes formules": "My formulas",
  "Aucune formule créée pour l’instant.": "No formula created yet.",
  "% · Résultats": "% · Results",
  "% · Progression": "% · Progress",
  "% · Parrainage": "% · Referral",
  "j actifs,": "active days,",
  "résultats distincts": "distinct results",
  "Calculer un classement": "Calculate a ranking",
  "Calculer": "Calculate",
  "Classement de tous les élèves": "Ranking of all students",
  "Validé": "Validated",
  "Brouillon": "Draft",
  "Pondérations : activité": "Weights: activity",
  "%, résultats": "%, results",
  "%, progression": "%, progress",
  "%, parrainage": "%, referral",
  "Classement complet de tous les élèves, du premier au dernier": "Full ranking of all students, from first to last",
  "Choix": "Choice",
  "Rang": "Rank",
  "Progression": "Progress",
  "Détail": "Details",
  "Sélectionner": "Select",
  "jours,": "days,",
  "résultats distincts,": "distinct results,",
  "parrainage(s)": "referral(s)",
  "Données insuffisantes": "Insufficient data",
  "Enregistrer jusqu’à cinq lauréats": "Save up to five winners",
  "Sélection officialisée — les lauréats ont été notifiés.": "Selection made official — the winners have been notified.",
  "Officialiser et notifier les lauréats": "Make official and notify the winners",
  "Nouvelle formule de classement": "New ranking formula",
  "Nom de la formule": "Formula name",
  "Début de période": "Period start",
  "Fin de période": "Period end",
  "Poids activité (%)": "Activity weight (%)",
  "Poids résultats (%)": "Results weight (%)",
  "Poids progression (%)": "Progress weight (%)",
  "Poids parrainage (%)": "Referral weight (%)",
  "Total des pondérations :": "Total weights:",
  "(doit faire 100 %)": "(must equal 100%)",
  "Jours actifs minimum": "Minimum active days",
  "Résultats distincts minimum": "Minimum distinct results",
  "Plafond minutes/jour": "Minutes/day cap",
  "Créer la formule": "Create the formula",
  "Générateurs d’épreuves classés par nombre total d’épreuves générées.": "Test generators ranked by total number of tests generated.",
  "Aucun générateur pour l’instant.": "No generator yet.",
  "Générateur": "Generator",
  "Épreuves générées": "Tests generated",
  "Enseignants de l’équipe (comptes internes) classés par durée de connexion cumulée, nombre d’assistances validées et contenus enregistrés.": "Team teachers (internal accounts) ranked by cumulative login time, number of validated support sessions and saved content.",
  "Aucun enseignant pour l’instant.": "No teacher yet.",
  "Connexion (min)": "Login (min)",
  "Assistances validées": "Validated support",
  "Contenus enregistrés": "Saved content",
  "Élèves à primer": "Students to reward",
  "Générateurs": "Generators",
  "Enseignants": "Teachers",
  "Classements": "Rankings",
  "maintenant ?": "now?",
  "Actif": "Active",
  "Suspendu": "Suspended",
  "Ouvre ou réduis le menu de ton espace.": "Open or collapse the menu of your space.",
  "La vue d'ensemble de la plateforme.": "The overview of the platform.",
  "Centre temps réel": "Real-time centre",
  "Qui est connecté, depuis quel appareil et où, en direct.": "Who is connected, from which device and where, live.",
  "Le contenu pédagogique": "Teaching content",
  "Modules, leçons, exercices, devoirs, QCM, vidéos et manuels.": "Modules, lessons, exercises, homework, quizzes, videos and textbooks.",
  "Les devoirs avec leur corrigé et leur barème.": "Homework with its answer key and marking scheme.",
  "Les utilisateurs": "Users",
  "Élèves, enseignants et comptes de la plateforme.": "Students, teachers and platform accounts.",
  "Les codes du personnel": "Staff codes",
  "Génère ici les codes d'inscription du comptable et de la Community Manager.": "Generate the sign-up codes for the accountant and the Community Manager here.",
  "La comptabilité": "Accounting",
  "Revenus, salaires et dépenses, avec leur circuit d'approbation.": "Revenue, salaries and expenses, with their approval workflow.",
  "La communication": "Communication",
  "Calendrier éditorial, contenus à faire valider, demandes et statistiques.": "Editorial calendar, content to validate, requests and statistics.",
  "La boîte de dépôt": "The drop box",
  "Documents à signer et communiqués ; un point rouge signale un document pas encore ouvert.": "Documents to sign and announcements; a red dot marks a document not yet opened.",
  "La messagerie": "Messaging",
  "Tes conversations ; les validations (dépenses, contenus) arrivent aussi ici.": "Your conversations; approvals (expenses, content) also arrive here.",
  "Les assistances": "Support requests",
  "Les élèves qui demandent de l'aide sur un exercice.": "Students asking for help with an exercise.",
  "Le point rouge disparaît quand tu ouvres la rubrique concernée.": "The red dot disappears when you open the related section.",
  "Revoir la visite": "Replay the tour",
  "Touche ce bouton pour relancer cette présentation à tout moment.": "Tap this button to restart this presentation at any time.",
  "Ta photo, ta signature et tes informations.": "Your photo, your signature and your details.",
  "TABLEAU DE BORD": "DASHBOARD",
  "Diagnostic e-mail": "Email diagnostics",
  "CONTENU PÉDAGOGIQUE": "TEACHING CONTENT",
  "Manuels": "Textbooks",
  "GESTION DES UTILISATEURS": "USER MANAGEMENT",
  "Utilisateurs": "Users",
  "Codes Manuels": "Textbook codes",
  "Codes Comptables": "Accountant codes",
  "Codes Community": "Community codes",
  "Codes Secrétariat": "Secretariat codes",
  "Codes Ambassadeurs": "Ambassador codes",
  "Prix des manuels": "Textbook prices",
  "Journal d'Audit": "Audit log",
  "Documents à valider": "Documents to validate",
  "SOUTIEN SCOLAIRE": "TUTORING",
  "Soutien scolaire": "Tutoring",
  "Rapports": "Reports",
  "COMPTABILITÉ": "ACCOUNTING",
  "Revenus": "Revenue",
  "Salaires": "Salaries",
  "Dépenses": "Expenses",
  "Calendrier éditorial": "Editorial calendar",
  "Contenus": "Content",
  "Communauté": "Community",
  "Statistiques": "Statistics",
  "Ressources de marque": "Brand resources",
  "SECRÉTARIAT": "SECRETARIAT",
  "Demandes et suivi": "Requests and follow-up",
  "Agenda": "Calendar",
  "Mes tâches": "My tasks",
  "Parents": "Parents",
  "Élèves": "Students",
  "Établissements": "Schools",
  "Manuels et commandes": "Textbooks and orders",
  "Courriers": "Mail",
  "Documents": "Documents",
  "Mon compte": "My account",
  "BRAND AMBASSADOR": "BRAND AMBASSADOR",
  "Nouvelle vente": "New sale",
  "Mes ventes": "My sales",
  "Versements": "Payments",
  "Stock de manuels": "Textbook stock",
  "Recouvrements": "Collections",
  "Reversements": "Remittances",
  "Performances": "Performance",
  "VENTES DE MANUELS": "TEXTBOOK SALES",
  "Brand Ambassadors": "Brand Ambassadors",
  "Ma Signature": "My signature",
  "Boîte de dépôt": "Drop box",
  "Rechercher une vente (élève, école, code)…": "Search a sale (student, school, code)…",
  "Rechercher un élève (nom, classe, école)…": "Search a student (name, class, school)…",
  "Rechercher un utilisateur, un email…": "Search a user, an email…",
  "Aide — revoir la visite guidée": "Help — replay the guided tour",
  "Vue d'ensemble de la plateforme Quick Learning": "Overview of the Quick Learning platform",
  "Total utilisateurs": "Total users",
  "élèves": "students",
  "Administrateurs": "Administrators",
  "Comptes inactifs": "Inactive accounts",
  "Contenu pédagogique": "Teaching content",
  "Classes": "Classes",
  "Activité globale": "Overall activity",
  "Tentatives QCM": "Quiz attempts",
  "Vidéos visionnées": "Videos watched",
  "Gérer les utilisateurs": "Manage users",
  "Voir l'activité": "See activity",
  "Matières enregistrées.": "Subjects saved.",
  "Erreur lors de la sauvegarde.": "Error while saving.",
  "Confirmer :": "Confirm:",
  "Le mot de passe doit contenir au moins 6 caractères.": "The password must contain at least 6 characters.",
  "Détails de l'utilisateur": "User details",
  "Dernière déconnexion": "Last logout",
  "Jamais": "Never",
  "Temps apprentissage": "Learning time",
  "Score moyen QCM": "Average quiz score",
  "Statut": "Status",
  "Non enregistré": "Not saved",
  "Code enseignant": "Teacher code",
  "Modifier le mot de passe": "Change the password",
  "Définir un mot de passe": "Set a password",
  "Nouveau mot de passe (min. 6 caractères)": "New password (min. 6 characters)",
  "Mot de passe mis à jour.": "Password updated.",
  "Erreur": "Error",
  "Leçons lues": "Lessons read",
  "Vidéos vues": "Videos watched",
  "Suspendre cet utilisateur": "Suspend this user",
  "Suspendre": "Suspend",
  "Activer cet utilisateur": "Activate this user",
  "Activer": "Activate",
  "Convertir cet utilisateur en Générateur d'épreuves ? Un code enseignant lui sera automatiquement attribué s'il n'en a pas.": "Convert this user into a Test generator? A teacher code will be assigned automatically if they don't have one.",
  "Statut GÉNÉRATEUR attribué. Code enseignant :": "GENERATOR status assigned. Teacher code:",
  "Communiquez ce code à l'utilisateur.": "Give this code to the user.",
  "Convertir en Générateur": "Convert to Generator",
  "Retirer le statut Générateur de cet utilisateur": "Remove the Generator status from this user",
  "Retirer statut Générateur": "Remove Generator status",
  "Supprimer définitivement cet utilisateur": "Permanently delete this user",
  "Erreur lors de la création.": "Error while creating.",
  "Créer un utilisateur": "Create a user",
  "Nom complet *": "Full name *",
  "Nom d'utilisateur *": "Username *",
  "Mot de passe *": "Password *",
  "Rôle *": "Role *",
  "— Non renseignée —": "— Not provided —",
  "Création…": "Creating…",
  "Créer": "Create",
  "Gérez les utilisateurs de la plateforme : consultez, modifiez et suivez leur activité.": "Manage the platform's users: view, edit and follow their activity.",
  "Nouvel utilisateur": "New user",
  "Rechercher un utilisateur…": "Search a user…",
  "Tous les rôles": "All roles",
  "Comptables": "Accountants",
  "Tous les statuts": "All statuses",
  "Réinitialiser": "Reset",
  "RÔLE": "ROLE",
  "DERNIÈRE DÉCONNEXION": "LAST LOGOUT",
  "DATE D'INSCRIPTION": "SIGN-UP DATE",
  "Journal d'audit": "Audit log",
  "Aucun utilisateur trouvé": "No user found",
  "Affichage": "Showing",
  "Leçon": "Lesson",
  "Aucune activité": "No activity",
  "utilisateur(s) actif(s) sur la plateforme": "active user(s) on the platform",
  "Rechercher un utilisateur ou une classe…": "Search a user or a class…",
  "Aucune activité enregistrée.": "No activity recorded.",
  "Sélectionnez un manuel pour consulter son contenu pédagogique.": "Select a textbook to view its teaching content.",
  "Aucun manuel disponible.": "No textbook available.",
  "module(s)": "module(s)",
  "Aucun module pour ce manuel.": "No module for this textbook.",
  "Leçons (": "Lessons (",
  "Vidéos (": "Videos (",
  "QCM (": "Quizzes (",
  "Exercices (": "Exercises (",
  "Aucune leçon disponible.": "No lesson available.",
  "question(s)": "question(s)",
  "Publié": "Published",
  "👨‍🏫 Enseignant": "👨‍🏫 Teacher",
  "👨‍🎓 Élève": "👨‍🎓 Student",
  "30 derniers jours": "Last 30 days",
  "16 dernières semaines": "Last 16 weeks",
  "12 derniers mois": "Last 12 months",
  "5 dernières années": "Last 5 years",
  "Demandes d'assistance": "Support requests",
  "Résolues": "Resolved",
  "Aucune demande": "No request",
  "résolue": "resolved",
  "Aucune réponse rédigée": "No written answer",
  "Déjà assisté par": "Already helped by",
  "Professeur": "Teacher",
  "Contacter l'élève": "Contact the student",
  "Marquer comme résolu": "Mark as resolved",
  "Assister des élèves": "Help students",
  "Mettre des cours en ligne": "Publish lessons",
  "Mettre des vidéos en ligne": "Publish videos",
  "Ajouter des exercices": "Add exercises",
  "Corriger des exercices": "Correct exercises",
  "Répondre aux questions des élèves": "Answer students' questions",
  "Créer des QCM": "Create quizzes",
  "Erreur lors de l'envoi du rapport.": "Error while sending the report.",
  "Rapport envoyé avec succès !": "Report sent!",
  "Votre rapport hebdomadaire a été transmis à la hiérarchie.": "Your weekly report has been sent to management.",
  "Nouveau rapport": "New report",
  "Rapport hebdomadaire": "Weekly report",
  "Rapport hebdomadaire de l'enseignant": "Teacher's weekly report",
  "PARTIE I": "PART I",
  "TÂCHES EFFECTUÉES": "TASKS COMPLETED",
  "Cochez les tâches que vous avez effectuées cette semaine.": "Tick the tasks you completed this week.",
  "Nombre": "Number",
  "PARTIE II": "PART II",
  "DIFFICULTÉS RENCONTRÉES": "DIFFICULTIES ENCOUNTERED",
  "Décrivez les difficultés que vous avez rencontrées cette semaine.": "Describe the difficulties you encountered this week.",
  "Ex : Manque de ressources pédagogiques, difficultés techniques sur la plateforme…": "E.g. Lack of teaching resources, technical issues on the platform…",
  "PARTIE III": "PART III",
  "SUGGESTIONS ET SOLLICITATIONS À LA HIÉRARCHIE": "SUGGESTIONS AND REQUESTS TO MANAGEMENT",
  "Partagez vos suggestions ou sollicitations à l'attention de la direction.": "Share your suggestions or requests for the management.",
  "Ex : Demande de formation, suggestion d'amélioration de la plateforme…": "E.g. Training request, suggestion to improve the platform…",
  "Ce rapport sera transmis à la hiérarchie sous forme de PDF téléchargeable.": "This report will be sent to management as a downloadable PDF.",
  "Envoi en cours…": "Sending…",
  "Envoyer le rapport": "Send the report",
  "Créer les paiements manquants pour tous les codes manuels déjà activés ?": "Create the missing payments for all textbook codes already activated?",
  "Erreur lors du remplissage.": "Error while filling in.",
  "Impossible de charger les rapports. Vérifiez que le serveur est démarré.": "Unable to load the reports. Check that the server is running.",
  "Revenus totaux (FCFA)": "Total revenue (FCFA)",
  "Vente Manuel (FCFA)": "Textbook sales (FCFA)",
  "FCFA perçus": "FCFA received",
  "Rapports & Statistiques": "Reports & Statistics",
  "Vue d'ensemble financière, abonnements, répartition géographique et activité enseignants.": "Financial overview, subscriptions, geographical distribution and teacher activity.",
  "Créer les entrées de revenus manquantes pour les codes manuels déjà activés": "Create the missing revenue entries for textbook codes already activated",
  "En cours…": "In progress…",
  "Sync revenus manuels": "Sync textbook revenue",
  "Cette semaine": "This week",
  "Ce mois": "This month",
  "Cette année": "This year",
  "Évolution des revenus": "Revenue over time",
  "Aucune donnée pour cette période": "No data for this period",
  "Répartition des forfaits": "Plan distribution",
  "Aucun abonnement enregistré": "No subscription recorded",
  "Méthodes de paiement": "Payment methods",
  "Aucun paiement enregistré": "No payment recorded",
  "Localisation des utilisateurs": "User locations",
  "position(s) enregistrée(s)": "position(s) recorded",
  "En ligne (": "Online (",
  "Hors ligne (": "Offline (",
  "Aucune position GPS enregistrée pour l'instant.": "No GPS position recorded yet.",
  "Les coordonnées sont capturées automatiquement à la connexion si l'utilisateur autorise la géolocalisation.": "Coordinates are captured automatically at login if the user allows geolocation.",
  "Élèves en ligne": "Students online",
  "Enseignants en ligne": "Teachers online",
  "Hors ligne (dernière position connue)": "Offline (last known position)",
  "Top établissements": "Top schools",
  "Aucune école enregistrée": "No school recorded",
  "Activité des enseignants": "Teacher activity",
  "Aucun enseignant enregistré.": "No teacher recorded.",
  "DERNIÈRE CONNEXION": "LAST LOGIN",
  "TEMPS SUR LA PLATEFORME": "TIME ON THE PLATFORM",
  "Télécharger le rapport PDF": "Download the PDF report",
  "Erreur lors de la génération.": "Error while generating.",
  "Supprimer ce code non activé ?": "Delete this non-activated code?",
  "Administration": "Administration",
  "Association de chaque code manuel à son propriétaire. Visible uniquement par le super administrateur.": "Link between each textbook code and its owner. Visible only to the super administrator.",
  "Générer des codes": "Generate codes",
  "Définir le prix de chaque manuel (FCFA)": "Set the price of each textbook (FCFA)",
  "Ce prix sera automatiquement enregistré comme revenu quand un étudiant activera un code de ce manuel.": "This price will automatically be recorded as revenue when a student activates a code for this textbook.",
  "Générer des codes manuels": "Generate textbook codes",
  "Les codes seront générés au format": "Codes will be generated in the format",
  "QL-ANNÉE-NUMÉRO-XXX": "QL-YEAR-NUMBER-XXX",
  "Manuel *": "Textbook *",
  "-- Choisir un manuel --": "-- Choose a textbook --",
  "Quantité *": "Quantity *",
  "Générer": "Generate",
  "codes générés avec succès !": "codes generated!",
  "…et": "…and",
  "Rechercher code, élève, manuel, école…": "Search code, student, textbook, school…",
  "Effacer": "Clear",
  "ÉLÈVE": "STUDENT",
  "ÉCOLE": "SCHOOL",
  "DATE D'ACTIVATION": "ACTIVATION DATE",
  "Non activé": "Not activated",
  "Aucun code trouvé": "No code found",
  "code(s) affiché(s) ·": "code(s) shown ·",
  "activé(s) sur": "activated out of",
  "leçon(s)": "lesson(s)",
  "vidéo(s)": "video(s)",
  "exercice(s)": "exercise(s)",
  "élément(s)": "item(s)",
  "Rechercher un(e)": "Search a",
  "Aucun élément trouvé.": "No item found.",
  "Cette section est en cours de développement.": "This section is under development.",
  "Gérez ce contenu depuis l'interface d'administration Django.": "Manage this content from the Django administration interface.",
  "Ouvrir l'admin Django": "Open the Django admin",
  "Groupes de discussion créés dans l'interface d'administration Django.": "Discussion groups created in the Django administration interface.",
  "Aucun groupe. Créez-en depuis l'interface Django Admin.": "No group. Create some from the Django Admin interface.",
  "membre(s) actif(s) sur": "active member(s) out of",
  "max — Classe :": "max — Class:",
  "Le diagnostic a échoué.": "The diagnostic failed.",
  "Vérifie pourquoi un e-mail (mot de passe oublié…) n'arrive pas : comptes liés à l'adresse, configuration Brevo, puis envoi d'un e-mail de test.": "Check why an email (forgotten password…) is not arriving: accounts linked to the address, Brevo configuration, then sending of a test email.",
  "adresse@exemple.com": "address@example.com",
  "Test en cours…": "Testing…",
  "Tester l'envoi": "Test sending",
  "Comptes liés à cette adresse :": "Accounts linked to this address:",
  "(désactivé)": "(disabled)",
  "Aucun compte n'utilise cette adresse : « mot de passe oublié » n'envoie rien (sans le dire, volontairement).": "No account uses this address: \"forgot password\" sends nothing (deliberately, without saying so).",
  "Limite atteinte : 5 demandes de réinitialisation par heure pour cette adresse. Réessayer plus tard.": "Limit reached: 5 reset requests per hour for this address. Try again later.",
  "Limite de tentatives non atteinte.": "Attempt limit not reached.",
  "Clé Brevo configurée (expéditeur :": "Brevo key configured (sender:",
  "Clé Brevo absente : ajouter BREVO_API_KEY dans les variables Railway.": "Brevo key missing: add BREVO_API_KEY to the Railway variables.",
  "Brevo a accepté l'e-mail de test. S'il n'arrive pas, regarder les spams puis Brevo → Transactionnel → Logs.": "Brevo accepted the test email. If it doesn't arrive, check spam, then Brevo → Transactional → Logs.",
  "Brevo a refusé l'e-mail de test :": "Brevo refused the test email:",
  "Accès refusé": "Access denied",
  "Accès refusé, car vous n'avez pas le niveau d'habilitation requis.": "Access denied, because you do not have the required clearance level.",
  "Cette section est réservée au super administrateur. Contactez votre administrateur système si vous pensez que c'est une erreur.": "This section is reserved for the super administrator. Contact your system administrator if you think this is a mistake.",
  "Définissez le prix de vente de chaque manuel. Ce montant sera automatiquement enregistré comme revenu lors de l'activation d'un code.": "Set the selling price of each textbook. This amount will automatically be recorded as revenue when a code is activated.",
  "Aucun manuel trouvé.": "No textbook found.",
  "Codes d'accès réservés au comptable — format QL-COMP-ANNÉE-NNNN-XXX. Séparés des codes manuels élèves.": "Access codes reserved for the accountant — format QL-COMP-YEAR-NNNN-XXX. Separate from student textbook codes.",
  "Codes Community Manager": "Community Manager codes",
  "Code à transmettre à la Community Manager : elle le saisit une seule fois, à son inscription, à la place du code manuel. Ensuite elle se connecte sans code.": "Code to give to the Community Manager: she enters it only once, when signing up, instead of the textbook code. After that she logs in without a code.",
  "secrétariat": "secretariat",
  "Code à transmettre au secrétariat : il est saisi une seule fois, à l'inscription, à la place du code manuel. Ensuite la connexion se fait sans code.": "Code to give to the secretariat: it is entered only once, when signing up, instead of the textbook code. After that, login is done without a code.",
  "Codes Brand Ambassadors": "Brand Ambassador codes",
  "Code à transmettre à un Brand Ambassador : il le saisit une seule fois, à l'inscription, à la place du code manuel. Ensuite la connexion se fait sans code.": "Code to give to a Brand Ambassador: they enter it only once, when signing up, instead of the textbook code. After that, login is done without a code.",
  "Supprimer ce code": "Delete this code",
  "Format :": "Format:",
  "Quantité": "Quantity",
  "Note (optionnel)": "Note (optional)",
  "Ex : Pour la": "E.g. For the",
  "code(s) généré(s) !": "code(s) generated!",
  "activé(s) ·": "activated ·",
  "disponible(s) ·": "available ·",
  "DATE ACTIVATION": "ACTIVATION DATE",
  "Activé": "Activated",
  "Aucun code": "No code",
  "Erreur lors de la génération PDF.": "Error while generating the PDF.",
  "Activité de @": "Activity of @",
  "Toutes les actions enregistrées sur la plateforme": "All actions recorded on the platform",
  "entrées": "entries",
  "Utilisateur": "User",
  "Nom ou @username": "Name or @username",
  "Du": "From",
  "Au": "To",
  "Source": "Source",
  "Toutes les sources": "All sources",
  "Plateforme": "Platform",
  "Fonction": "Function",
  "Toutes les fonctions": "All functions",
  "Filtrer": "Filter",
  "Exporter PDF": "Export PDF",
  "Aucune action enregistrée pour ces critères.": "No action recorded for these criteria.",
  "Action": "Action",
  "Cible": "Target",
  "Détails": "Details",
  "Live mis à jour.": "Live updated.",
  "Live créé.": "Live created.",
  "Erreur lors de l'enregistrement.": "Error while saving.",
  "Supprimer \"": "Delete \"",
  "Erreur lors de la suppression.": "Error while deleting.",
  "Erreur mise à jour statut.": "Error updating the status.",
  "EN COURS 🔴": "LIVE NOW 🔴",
  "Terminé": "Ended",
  "Nouveau Live": "New live",
  "Modifier le live": "Edit the live",
  "Créer un live": "Create a live",
  "Titre *": "Title *",
  "URL YouTube *": "YouTube URL *",
  "Accepte les liens YouTube Watch, Live et Shorts.": "Accepts YouTube Watch, Live and Shorts links.",
  "Manuel concerné *": "Textbook concerned *",
  "— Sélectionner un manuel —": "— Select a textbook —",
  "Seuls les élèves ayant activé un code de ce manuel auront accès.": "Only students who have activated a code for this textbook will have access.",
  "Date et heure *": "Date and time *",
  "Description": "Description",
  "Aucun live programmé.": "No live scheduled.",
  "Titre": "Title",
  "Actions": "Actions",
  "En cours 🔴": "Live now 🔴",
  "Voir sur YouTube": "View on YouTube",
  "Enregistrement impossible.": "Unable to save.",
  "Supprimer cette formule ?": "Delete this formula?",
  "Chaque formule est rattachée à un manuel : seuls les élèves de ce manuel la voient.": "Each formula is attached to a textbook: only students of that textbook can see it.",
  "Tous les manuels": "All textbooks",
  "Sans manuel (invisibles)": "No textbook (invisible)",
  "Ajouter une formule": "Add a formula",
  "Modifier la formule": "Edit the formula",
  "Ex: Loi d'Ohm": "E.g. Ohm's law",
  "Formule / Contenu *": "Formula / Content *",
  "(LaTeX ou texte)": "(LaTeX or text)",
  "Ex: U = R × I ou $U = R \\cdot I$": "E.g. U = R × I or $U = R \\cdot I$",
  "Commentaire explicatif": "Explanatory comment",
  "Explication, conditions d'application…": "Explanation, conditions of application…",
  "— Choisir un manuel —": "— Choose a textbook —",
  "Module associé": "Linked module",
  "— Aucun module (formule générale du manuel) —": "— No module (general formula of the textbook) —",
  "URL Vidéo YouTube": "YouTube video URL",
  "Image illustrative": "Illustration image",
  "Fichier PDF": "PDF file",
  "PDF actuel": "Current PDF",
  "Visible par les élèves": "Visible to students",
  "Aucune formule. Cliquez sur \"Ajouter une formule\".": "No formula. Click \"Add a formula\".",
  "Sans manuel": "No textbook",
  "Visible": "Visible",
  "Masqué": "Hidden",
  "Signature enregistrée !": "Signature saved!",
  "Supprimer votre signature ?": "Delete your signature?",
  "Signature supprimée.": "Signature deleted.",
  "Ma Signature Numérique": "My digital signature",
  "Dessinez ou importez votre signature. Elle sera apposée sur les documents que vous signerez.": "Draw or import your signature. It will be placed on the documents you sign.",
  "Signature enregistrée": "Signature saved",
  "Dessiner": "Draw",
  "Importer une image": "Import an image",
  "Tracez votre signature dans le cadre ci-dessous :": "Draw your signature in the box below:",
  "Importez une image PNG/JPG de votre signature :": "Import a PNG/JPG image of your signature:",
  "Facture versée et signée. Copie renvoyée à l'expéditeur.": "Invoice paid and signed. Copy sent back to the sender.",
  "Erreur lors de la signature.": "Error while signing.",
  "Signé": "Signed",
  "Refusé": "Refused",
  "Boîte de signature": "Signature box",
  "Rédiger un communiqué": "Write an announcement",
  "Créer une facture": "Create an invoice",
  "Envoyer un document à signer": "Send a document for signature",
  "Reçus": "Received",
  "À signer": "To sign",
  "Envoyés": "Sent",
  "Factures": "Invoices",
  "Aucun document reçu.": "No document received.",
  "Pas encore ouvert": "Not opened yet",
  "De :": "From:",
  "Motif :": "Reason:",
  "(signé)": "(signed)",
  "Traiter": "Process",
  "Aucun document envoyé.": "No document sent.",
  "Traité le :": "Processed on:",
  "Motif refus :": "Refusal reason:",
  "Télécharger signé": "Download signed",
  "Aucune facture reçue.": "No invoice received.",
  "· Par :": "· By:",
  "Versé et signé le": "Paid and signed on",
  "Versé + Signer": "Paid + Sign",
  "Document envoyé ! Le signataire a été notifié.": "Document sent! The signer has been notified.",
  "Document traité.": "Document processed.",
  "Communiqué \"": "Announcement \"",
  "\" envoyé et téléchargé.": "\" sent and downloaded.",
  "Facture": "Invoice",
  "générée et téléchargée. Copie dans votre boîte.": "generated and downloaded. Copy in your box.",
  "Espèces": "Cash",
  "Autre": "Other",
  "Le nom du client est requis.": "The client's name is required.",
  "Complétez toutes les lignes.": "Complete all the lines.",
  "la facture": "the invoice",
  "Client": "Client",
  "Classe (si élève)": "Class (if student)",
  "Ex: 3ème, Terminale C...": "E.g. 3ème, Terminale C...",
  "Prestations": "Services",
  "Qté": "Qty",
  "Prix unit. (F)": "Unit price (F)",
  "Montant": "Amount",
  "Ex: Manuel Math 3ème / Abonnement / Cours…": "E.g. Maths textbook 3ème / Subscription / Lesson…",
  "Abonnement": "Subscription",
  "Code manuel": "Textbook code",
  "Ex: AK-12345": "E.g. AK-12345",
  "Ajouter une ligne": "Add a line",
  "Sous-total": "Subtotal",
  "Remise (F CFA)": "Discount (F CFA)",
  "TOTAL NET": "NET TOTAL",
  "Mode de paiement": "Payment method",
  "Notes (optionnel)": "Notes (optional)",
  "Informations complémentaires...": "Additional information...",
  "Génération…": "Generating…",
  "Générer et signer (": "Generate and sign (",
  "Veuillez sélectionner un fichier PDF.": "Please select a PDF file.",
  "Veuillez choisir un signataire.": "Please choose a signer.",
  "Erreur lors du dépôt.": "Error while uploading.",
  "Signataire *": "Signer *",
  "-- Choisir --": "-- Choose --",
  "Titre du document *": "Document title *",
  "Bulletin de paie": "Payslip",
  "Rapport": "Report",
  "Message (optionnel)": "Message (optional)",
  "Fichier PDF *": "PDF file *",
  "Choisissez une action.": "Choose an action.",
  "le document signé": "the signed document",
  "Erreur lors du traitement.": "Error while processing.",
  "Traiter le document": "Process the document",
  "Consulter le document original": "View the original document",
  "Votre décision *": "Your decision *",
  "Signer": "Sign",
  "Motif du refus (optionnel)": "Refusal reason (optional)",
  "Expliquez pourquoi vous refusez…": "Explain why you are refusing…",
  "Votre signature sera apposée sur le document. Le déposant sera notifié et pourra télécharger le PDF signé.": "Your signature will be placed on the document. The sender will be notified and will be able to download the signed PDF.",
  "✍ Signer et télécharger": "✍ Sign and download",
  "❌ Confirmer le refus": "❌ Confirm the refusal",
  "L'objet est requis.": "The subject is required.",
  "Le corps du communiqué est requis.": "The body of the announcement is required.",
  "Sélectionnez au moins un destinataire.": "Select at least one recipient.",
  "le communiqué": "the announcement",
  "Rédiger un communiqué officiel": "Write an official announcement",
  "Le communiqué sera généré en PDF avec le logo Quick Learning et votre signature numérique, puis envoyé aux destinataires sélectionnés.": "The announcement will be generated as a PDF with the Quick Learning logo and your digital signature, then sent to the selected recipients.",
  "Destinataire(s) *": "Recipient(s) *",
  "Aucun membre disponible.": "No member available.",
  "destinataire(s) sélectionné(s)": "recipient(s) selected",
  "Objet *": "Subject *",
  "Ex : Réunion pédagogique du 30 juin 2026": "E.g. Teaching meeting of 30 June 2026",
  "Corps du communiqué *": "Body of the announcement *",
  "Madame, Monsieur, Nous vous informons que... En vous souhaitant bonne réception,": "Dear Sir or Madam, We inform you that... Kind regards,",
  "Chaque paragraphe séparé par une ligne vide sera mis en forme automatiquement.": "Each paragraph separated by an empty line will be formatted automatically.",
  "Génération en cours…": "Generating…",
  "Signer, envoyer et télécharger": "Sign, send and download",
  "Connectez-vous pour accéder à votre parrainage.": "Log in to access your referrals.",
  "Impossible de charger le parrainage.": "Unable to load the referrals.",
  "← Retour à Quick Learning": "← Back to Quick Learning",
  "Parrainage des élèves": "Student referrals",
  "Chargement du parrainage…": "Loading referrals…",
  "Le programme est en préparation. Votre code peut être partagé, mais aucun jour n’est attribué tant que les conditions commerciales ne sont pas activées.": "The programme is being prepared. Your code can be shared, but no days are granted until the commercial conditions are activated.",
  "Votre code personnel de parrainage": "Your personal referral code",
  "Copié": "Copied",
  "Copier": "Copy",
  "Jours attribués": "Days granted",
  "Suivi": "Tracking",
  "Aucun parrainage pour le moment.": "No referral yet.",
  "Parrainage #": "Referral #",
  "jour(s)": "day(s)",
  "Les coordonnées, achats et paiements des filleuls ne sont jamais affichés.": "Referees' contact details, purchases and payments are never shown.",
  "Une erreur est survenue.": "An error occurred.",
  "Approuvé": "Approved",
  "Nouvelle": "New",
  "Prise de contact": "Initial contact",
  "Confirmée": "Confirmed",
  "Effectuée": "Completed",
  "Annulée": "Cancelled",
  "À domicile": "At home",
  "Chez l’intervenant": "At the tutor's place",
  "Signalé": "Reported",
  "Modération enregistrée.": "Moderation saved.",
  "Enseignants inscrits pour le soutien scolaire. Cliquez sur une carte pour voir le profil complet, l’approuver, la refuser, la suspendre, ou gérer les demandes des parents.": "Teachers registered for tutoring. Click a card to see the full profile, approve it, refuse it, suspend it or manage parents' requests.",
  "Aucun enseignant inscrit pour le moment.": "No teacher registered yet.",
  "Intervenant indépendant": "Independent tutor",
  "Matières": "Subjects",
  "Modification d'une fiche déjà publiée (l'ancienne version reste en ligne)": "Edit of a profile already published (the old version stays online)",
  "de cours": "of lessons",
  "Profil enseignant": "Teacher profile",
  "Ville": "City",
  "La version approuvée précédente reste visible des parents jusqu'à votre décision.": "The previously approved version remains visible to parents until your decision.",
  "Modalités": "Formats",
  "Disponibilités": "Availability",
  "Motif": "Reason",
  "PRÉSENTATION": "INTRODUCTION",
  "MATIÈRES": "SUBJECTS",
  "Approuver": "Approve",
  "Motif obligatoire": "Reason required",
  "PARENTS AYANT SOLLICITÉ CET ENSEIGNANT (": "PARENTS WHO CONTACTED THIS TEACHER (",
  "Aucune demande pour le moment.": "No request yet.",
  "· Classe :": "· Class:",
  "· Matière :": "· Subject:",
  "Lieu :": "Place:",
  "Disponibilités :": "Availability:",
  "AVIS DES PARENTS (": "PARENTS' REVIEWS (",
  "Aucun avis pour le moment.": "No review yet.",
  "Signalement :": "Report:",
  "Publier": "Publish",
  "Accès refusé. Votre compte doit avoir le statut Staff dans Django admin.": "Access denied. Your account must have Staff status in the Django admin.",
  "Impossible de charger les activités. Vérifiez que le serveur est démarré.": "Unable to load the activities. Check that the server is running.",
  "Activités de tous les élèves": "Activities of all students",
  "Rechercher un élève ou une activité…": "Search a student or an activity…",
  "Corrigé (enseignants)": "Answer key (teachers)",
  "? À utiliser en dernier recours, après tes explications.": "? To be used as a last resort, after your explanations.",
  "Le corrigé a déjà été envoyé. L'envoyer à nouveau": "The answer key has already been sent. Send it again",
  "Envoyer le corrigé complet à cet élève": "Send the full answer key to this student",
  "Corrigé envoyé à l'élève.": "Answer key sent to the student.",
  "(déjà envoyé)": "(already sent)",
  "Envoyer la correction à l'élève": "Send the correction to the student",
  "Dépense approuvée.": "Expense approved.",
  "Dépense refusée.": "Expense refused.",
  "Décision impossible.": "Decision not possible.",
  "· demandée par": "· requested by",
  "la comptabilité": "accounting",
  "Voir le justificatif": "View the receipt",
  "Justificatif —": "Receipt —",
  "≥ 20 000 FCFA : approbation réservée au CEO.": "≥ 20,000 FCFA: approval reserved for the CEO.",
  "< 20 000 FCFA : un super admin peut l'approuver.": "< 20,000 FCFA: a super admin can approve it.",
  "Motif du refus (facultatif)": "Refusal reason (optional)",
  "Confirmer le refus": "Confirm the refusal",
  "Pour information : le CEO doit approuver cette dépense.": "For information: the CEO must approve this expense.",
  "En attente d'approbation par un super admin.": "Awaiting approval by a super admin.",
  "Décision :": "Decision:",
  ", par": ", by",
  "Précisez la correction attendue.": "Specify the expected correction.",
  "Contenu validé.": "Content validated.",
  "Correction demandée.": "Correction requested.",
  "· prévu le": "· scheduled on",
  "· préparé par": "· prepared by",
  "la Community Manager": "the Community Manager",
  "Campagne :": "Campaign:",
  "Voir le document": "View the document",
  "Lien :": "Link:",
  "Correction attendue": "Expected correction",
  "Envoyer la demande de correction": "Send the correction request",
  "Demander une correction": "Request a correction",
  "En attente de validation par un super admin.": "Awaiting validation by a super admin.",
  "Correction demandée :": "Correction requested:",
  "Validé par": "Validated by",
  "Publié :": "Published:",
  "la correction": "the correction",
  "Erreur lors de la correction.": "Error while correcting.",
  "Rendu élève": "Student submission",
  "Envoyer le corrigé à l'élève": "Send the answer key to the student",
  "la copie de l'élève": "the student's work",
  "le corrigé (enseignants)": "the answer key (teachers)",
  "Mettez une note pour pouvoir envoyer le corrigé.": "Enter a grade to be able to send the answer key.",
  "Aucun corrigé PDF n'est encore disponible pour cette évaluation : le bouton d'envoi apparaîtra dès qu'il sera ajouté.": "No PDF answer key is available yet for this assessment: the send button will appear as soon as one is added.",
  "Vous avez corrigé ce": "You corrected this",
  "— Note actuelle :": "— Current grade:",
  "Modifier la correction :": "Edit the correction:",
  "Corriger ce": "Correct this",
  "Note (ex: 15/20)": "Grade (e.g. 15/20)",
  "Commentaire pour l'élève…": "Comment for the student…",
  "Joindre un fichier de correction (optionnel)": "Attach a correction file (optional)",
  "Correction enregistrée.": "Correction saved.",
  "Mettre à jour la correction": "Update the correction",
  "Envoyer la correction": "Send the correction",
  "Conversation transférée avec succès.": "Conversation transferred.",
  "Impossible de transférer cette conversation.": "Unable to transfer this conversation.",
  "Confier à un autre professeur": "Hand over to another teacher",
  "Prendre en charge": "Take charge",
  "Terminer": "Finish",
  "Bloquer": "Block",
  "Débloquer": "Unblock",
  "Exclure": "Remove",
  "Confier l'élève à un autre professeur": "Hand the student over to another teacher",
  "La conversation avec": "The conversation with",
  "sera transférée à l'enseignant choisi.": "will be transferred to the chosen teacher.",
  "Aucun autre enseignant disponible.": "No other teacher available.",
  "demande(s) en cours": "request(s) in progress",
  "Bienvenue sur Quick Learning !": "Welcome to Quick Learning!",
  "Votre plateforme de soutien scolaire au Cameroun. Accédez à vos cours, QCM, vidéos pédagogiques, exercices notés et formules utiles — le tout organisé selon votre manuel scolaire. Faites défiler ces slides pour découvrir toutes les fonctionnalités disponibles.": "Your tutoring platform in Cameroon. Access your lessons, quizzes, teaching videos, graded exercises and useful formulas — all organised according to your school textbook. Scroll through these slides to discover all the available features.",
  "Connexion & Code manuel": "Login & textbook code",
  "Pour vous connecter, saisissez votre nom d'utilisateur et votre mot de passe. Si vous êtes élève, ajoutez le code manuel trouvé à l'intérieur de votre livre papier (format : QL-PHY-TLE-1-XXX). Astuce : les espaces se convertissent automatiquement en tirets pendant la saisie.": "To log in, enter your username and password. If you are a student, add the textbook code found inside your paper book (format: QL-PHY-TLE-1-XXX). Tip: spaces are automatically converted to hyphens as you type.",
  "Votre tableau de bord": "Your dashboard",
  "Une fois connecté, votre tableau de bord affiche un résumé de votre progression. Le menu latéral à gauche vous donne accès à toutes les sections : Leçons, QCM, Vidéos, Exercices, Devoirs, Formules utiles, Messagerie, Résultats et bien plus. Sur mobile, ouvrez-le avec le bouton ☰ en haut.": "Once logged in, your dashboard shows a summary of your progress. The side menu on the left gives you access to all sections: Lessons, Quizzes, Videos, Exercises, Homework, Useful formulas, Messaging, Results and much more. On mobile, open it with the ☰ button at the top.",
  "Leçons interactives": "Interactive lessons",
  "Vos leçons sont organisées par module selon votre manuel. Cliquez sur une leçon pour la lire, visualiser les schémas et prendre des notes. La plateforme retient automatiquement votre progression — une coche verte indique les leçons déjà consultées.": "Your lessons are organised by module according to your textbook. Click a lesson to read it, view the diagrams and take notes. The platform automatically remembers your progress — a green tick shows lessons already viewed.",
  "QCM — Questions à choix multiples": "Quizzes — Multiple-choice questions",
  "Chaque module propose des QCM (Questions à Choix Multiples) chronométrés pour tester vos connaissances. Répondez aux questions, soumettez vos réponses et consultez immédiatement votre score ainsi que les corrections détaillées pour comprendre vos erreurs.": "Each module offers timed multiple-choice quizzes to test your knowledge. Answer the questions, submit your answers and immediately see your score and detailed corrections to understand your mistakes.",
  "Vidéos pédagogiques": "Teaching videos",
  "Des vidéos pédagogiques accompagnent vos leçons pour mieux comprendre les concepts difficiles. Les vidéos se lancent directement depuis la plateforme avec le lecteur intégré. Votre historique de visionnage est sauvegardé pour que vous puissiez reprendre là où vous avez arrêté.": "Teaching videos accompany your lessons to help you understand difficult concepts. Videos play directly on the platform with the built-in player. Your viewing history is saved so you can resume where you stopped.",
  "Exercices & Devoirs": "Exercises & Homework",
  "Les exercices interactifs vous permettent de pratiquer et d'auto-évaluer vos acquis. Si vous bloquez sur une question, vous pouvez demander l'aide d'un enseignant directement depuis l'exercice. Vos soumissions sont enregistrées et vos résultats consultables à tout moment.": "Interactive exercises let you practise and assess yourself. If you get stuck on a question, you can ask a teacher for help directly from the exercise. Your submissions are saved and your results can be viewed at any time.",
  "La section Formules utiles regroupe toutes les formules mathématiques et scientifiques importantes, classées par module. Chaque formule est affichée en notation mathématique lisible. Les images associées peuvent être agrandies en plein écran d'un simple clic pour mieux visualiser les schémas.": "The Useful formulas section gathers all the important mathematical and scientific formulas, sorted by module. Each formula is shown in readable mathematical notation. The associated images can be enlarged to full screen with a single click to see the diagrams better.",
  "Messagerie avec vos enseignants": "Messaging with your teachers",
  "La messagerie intégrée vous permet de communiquer directement avec vos enseignants et vos camarades. Posez vos questions, partagez vos difficultés et recevez des réponses personnalisées. La messagerie prend en charge les formules mathématiques pour faciliter les explications scientifiques.": "Built-in messaging lets you communicate directly with your teachers and classmates. Ask your questions, share your difficulties and receive personalised answers. Messaging supports mathematical formulas to make scientific explanations easier.",
  "Notifications & Calculatrice": "Notifications & Calculator",
  "Soyez informé en temps réel des nouvelles formules, corrections de devoirs et messages de vos enseignants. La cloche en haut à droite affiche le nombre de notifications non lues. La calculatrice scientifique flottante est disponible à tout moment depuis la barre supérieure.": "Be informed in real time of new formulas, homework corrections and messages from your teachers. The bell at the top right shows the number of unread notifications. The floating scientific calculator is available at any time from the top bar.",
  "Devoirs notés avec délai": "Graded homework with deadlines",
  "Vos enseignants publient des devoirs avec une date limite de soumission. Vous devez rédiger votre réponse et la soumettre avant l'heure fixée. Une fois le délai écoulé, l'enseignant corrige votre travail, laisse un commentaire et vous attribue une note visible directement sur la plateforme.": "Your teachers publish homework with a submission deadline. You must write your answer and submit it before the set time. Once the deadline has passed, the teacher corrects your work, leaves a comment and gives you a grade visible directly on the platform.",
  "Recherche par code de contenu": "Search by content code",
  "Chaque leçon, exercice ou QCM de votre manuel papier possède un code unique. Saisissez ce code dans la barre de recherche de la plateforme pour accéder instantanément au contenu correspondant — plus besoin de parcourir toutes les sections pour retrouver un exercice précis.": "Each lesson, exercise or quiz in your paper textbook has a unique code. Enter this code in the platform's search bar to access the corresponding content instantly — no need to browse every section to find a specific exercise.",
  "Suivi de vos notes & activités": "Track your grades & activities",
  "La section Résultats & Activités vous donne une vue complète de vos performances : notes obtenues aux QCM, exercices et devoirs, temps passé sur la plateforme, leçons consultées et progression par module. Utilisez ces données pour identifier vos points forts et les chapitres à renforcer.": "The Results & Activities section gives you a complete view of your performance: quiz, exercise and homework grades, time spent on the platform, lessons viewed and progress by module. Use this data to identify your strengths and the chapters to work on.",
  "Groupes d'études entre élèves": "Study groups between students",
  "Rejoignez ou découvrez des groupes d'études créés par vos enseignants. Au sein d'un groupe, les élèves d'une même classe peuvent échanger, poser des questions, partager des ressources et s'entraider mutuellement. C'est l'espace idéal pour réviser en équipe et progresser ensemble sans blocage.": "Join or discover study groups created by your teachers. Within a group, students of the same class can talk, ask questions, share resources and help each other. It is the ideal space to revise as a team and progress together.",
  "📸 Capture d'écran à venir": "📸 Screenshot coming soon",
  "Ignorer la présentation": "Skip the presentation",
  "Assistant intégré : il répond aux questions sur l'utilisation de votre espace, sans IA en ligne.": "Built-in assistant: it answers questions about how to use your space, without online AI.",
  "Je ne peux pas répondre pour le moment. Vérifiez votre connexion puis réessayez.": "I can't answer right now. Check your connection and try again.",
  "Ouvrir l'assistant Quick Learning": "Open the Quick Learning assistant",
  "Assistant": "Assistant",
  "Assistant Quick Learning": "Quick Learning assistant",
  "Espace": "Space",
  "aide intégrée": "built-in help",
  "Fermer l'assistant": "Close the assistant",
  "L'assistant écrit": "The assistant is typing",
  "Questions suggérées": "Suggested questions",
  "Votre question…": "Your question…",
  "Votre question": "Your question",
  "✓ Profil validé": "✓ Validated profile",
  "Classes :": "Classes:",
  "À partir de": "From",
  "Voir le profil": "View the profile",
  "Solliciter": "Request",
  "ACCOMPAGNEMENT SCOLAIRE • CAMEROUN": "TUTORING • CAMEROON",
  "Le bon professeur pour accompagner la réussite de votre enfant.": "The right teacher to support your child's success.",
  "Découvrez des enseignants aux profils validés, comparez leurs matières et leurs tarifs, puis envoyez votre demande de soutien en quelques clics.": "Discover teachers with validated profiles, compare their subjects and rates, then send your tutoring request in a few clicks.",
  "Trouver un professeur →": "Find a teacher →",
  "Comment ça marche ?": "How does it work?",
  "✓ Profils examinés ✓ Demandes suivies ✓ Coordonnées privées protégées": "✓ Reviewed profiles ✓ Tracked requests ✓ Private contact details protected",
  "Un accompagnement adapté à chaque élève": "Support adapted to every student",
  "À domicile · En ligne · Selon les disponibilités": "At home · Online · Depending on availability",
  "Explorez les profils": "Explore the profiles",
  "Choisissez un enseignant": "Choose a teacher",
  "Envoyez votre demande": "Send your request",
  "Professeurs à découvrir": "Teachers to discover",
  "Voir tout l'annuaire →": "See the whole directory →",
  "Les premiers profils validés apparaîtront ici très bientôt.": "The first validated profiles will appear here very soon.",
  "Comment fonctionne le soutien scolaire ?": "How does tutoring work?",
  "1. Recherchez": "1. Search",
  "Filtrez par matière, classe, ville et modalité. L'annuaire est consultable sans compte.": "Filter by subject, class, city and format. The directory can be viewed without an account.",
  "2. Comparez": "2. Compare",
  "Consultez les profils validés, les tarifs indiqués par les enseignants et leurs disponibilités.": "View the validated profiles, the rates set by the teachers and their availability.",
  "3. Demandez": "3. Request",
  "Créez votre compte parent puis envoyez votre demande : l'équipe Quick Learning organise la mise en relation et vous suivez son avancement.": "Create your parent account then send your request: the Quick Learning team arranges the contact and you follow its progress.",
  "Les coordonnées des enseignants, des parents et des élèves ne sont jamais publiées. La mise en relation passe par une demande encadrée.": "The contact details of teachers, parents and students are never published. Contact goes through a supervised request.",
  "ANNUAIRE DES ENSEIGNANTS": "TEACHER DIRECTORY",
  "Trouvez votre professeur idéal": "Find your ideal teacher",
  "Consultez librement les profils. Un compte est requis uniquement pour solliciter un cours.": "Browse the profiles freely. An account is only required to request a lesson.",
  "Filtres de l'annuaire": "Directory filters",
  "Toutes les matières": "All subjects",
  "Toutes les classes": "All classes",
  "Toutes les villes": "All cities",
  "Modalité": "Format",
  "Toutes les modalités": "All formats",
  "Rechercher": "Search",
  "enseignant(s) correspondant à votre recherche": "teacher(s) matching your search",
  "Aucun résultat pour ces filtres. Essayez une autre recherche.": "No results for these filters. Try another search.",
  "Pages de l'annuaire": "Directory pages",
  "← Précédent": "← Previous",
  "Page": "Page",
  "Suivant →": "Next →",
  "Ce profil n'est pas disponible.": "This profile is not available.",
  "Choisissez une note avant de valider.": "Choose a rating before confirming.",
  "Votre avis a bien été envoyé, merci !": "Your review has been sent, thank you!",
  "Votre avis sur le cours effectué": "Your review of the lesson",
  "Note": "Rating",
  "sur 5": "out of 5",
  "Commentaire (50 caractères maximum)": "Comment (50 characters maximum)",
  "Envoyer mon avis": "Send my review",
  "← Retour à l'annuaire": "← Back to the directory",
  "À propos de l'enseignant": "About the teacher",
  "Classes accompagnées": "Classes supported",
  "Disponibilités indiquées": "Availability given",
  "Les coordonnées personnelles ne sont pas publiées. La mise en relation passe par une demande encadrée sur Quick Learning.": "Personal contact details are not published. Contact goes through a supervised request on Quick Learning.",
  "Tarif indicatif déclaré": "Declared indicative rate",
  "Le tarif et les conditions définitives sont à confirmer lors de la mise en relation.": "The final rate and conditions are to be confirmed when contact is made.",
  "Tarif non renseigné : il sera précisé lors de la mise en relation.": "Rate not provided: it will be specified when contact is made.",
  "Solliciter cet enseignant →": "Request this teacher →",
  "Si cet email est enregistré, un lien de réinitialisation vient de vous être envoyé.": "If this email is registered, a reset link has just been sent to you.",
  "ESPACE PARENT": "PARENT SPACE",
  "Mot de passe oublié": "Forgot password",
  "Indiquez l'email utilisé lors de votre inscription : un lien de réinitialisation vous sera envoyé.": "Enter the email used when you signed up: a reset link will be sent to you.",
  "← Retour à la connexion": "← Back to login",
  "Heureux de vous retrouver !": "Good to see you again!",
  "Connectez-vous pour envoyer et suivre vos demandes de soutien.": "Log in to send and track your tutoring requests.",
  "Connexion…": "Logging in…",
  "Créer un compte parent": "Create a parent account",
  "Le mot de passe doit contenir au moins 8 caractères.": "The password must contain at least 8 characters.",
  "Les deux mots de passe ne correspondent pas.": "The two passwords do not match.",
  "Votre compte parent est créé.": "Your parent account has been created.",
  "INSCRIPTION PARENT": "PARENT SIGN-UP",
  "Créez votre compte en quelques étapes": "Create your account in a few steps",
  "Aucun code manuel requis. Ce compte n'ouvre pas l'accès aux contenus payants ni aux données scolaires d'un élève.": "No textbook code required. This account does not give access to paid content or to a student's school data.",
  "sur 2": "of 2",
  "1. Vos coordonnées": "1. Your details",
  "2. Sécurité": "2. Security",
  "Quartier (facultatif)": "Neighbourhood (optional)",
  "Continuer →": "Continue →",
  "Les informations sur votre enfant seront demandées uniquement lors d'une demande de cours, selon les besoins.": "Information about your child will only be requested when you ask for a lesson, as needed.",
  "← Retour": "← Back",
  "Créer mon compte": "Create my account",
  "Déjà inscrit ?": "Already registered?",
  "Choisissez au moins une matière.": "Choose at least one subject.",
  "Votre demande a bien été envoyée. Vous pouvez suivre son avancement dans « Mes demandes ».": "Your request has been sent. You can follow its progress in \"My requests\".",
  "← Retour au profil": "← Back to the profile",
  "DEMANDE DE SOUTIEN": "TUTORING REQUEST",
  "Organisons le soutien de votre enfant": "Let's organise your child's tutoring",
  "Enseignant sélectionné :": "Selected teacher:",
  "Prénom ou initiales de l'élève": "Student's first name or initials",
  "Ex. : Amina": "E.g. Amina",
  "Choisir une classe": "Choose a class",
  "Matières souhaitées": "Desired subjects",
  "(une ou plusieurs)": "(one or more)",
  "Choisir une modalité": "Choose a format",
  "Ville / quartier": "City / neighbourhood",
  "Ex. : Yaoundé, Bastos": "E.g. Yaoundé, Bastos",
  "Ex. : mercredi après-midi": "E.g. Wednesday afternoon",
  "Objectif du soutien (facultatif)": "Goal of the tutoring (optional)",
  "Difficultés, objectifs, fréquence souhaitée…": "Difficulties, goals, desired frequency…",
  "Votre demande est visible uniquement par les personnes autorisées à la traiter. Les coordonnées privées ne sont pas rendues publiques. N'indiquez ni adresse exacte ni nom complet de l'enfant.": "Your request is visible only to the people authorised to handle it. Private contact details are not made public. Do not give an exact address or the child's full name.",
  "Envoyer ma demande →": "Send my request →",
  "Lieu": "Place",
  "Objectif": "Goal",
  "Échange avec l'équipe Quick Learning": "Chat with the Quick Learning team",
  "Aucun message pour le moment.": "No message yet.",
  "Interlocuteur": "Contact person",
  "Votre message": "Your message",
  "Un membre de l'équipe sera associé à cette demande.": "A team member will be assigned to this request.",
  "Annuler cette demande de soutien ?": "Cancel this tutoring request?",
  "Demande annulée.": "Request cancelled.",
  "Espace parent": "Parent space",
  "Mes demandes": "My requests",
  "Trouver un professeur": "Find a teacher",
  "Mes demandes de soutien": "My tutoring requests",
  "Retrouvez vos demandes et leur état d'avancement.": "Find your requests and their progress.",
  "+ Nouvelle demande": "+ New request",
  "Demandes": "Requests",
  "Confirmées": "Confirmed",
  "Vous n'avez pas encore de demande.": "You don't have any request yet.",
  "Soutien": "Tutoring",
  "envoyée le": "sent on",
  "Masquer le suivi": "Hide tracking",
  "Voir le suivi": "See tracking",
  "Annuler la demande": "Cancel the request",
  "Espace parents et soutien scolaire": "Parent space and tutoring",
  "Cette nouveauté est désactivée sur cet environnement.": "This feature is disabled on this environment.",
  "Quick Learning — accueil du site": "Quick Learning — site home",
  "Créer un compte": "Create an account",
  "Quick Learning · Soutien scolaire · Profils validés et demandes encadrées": "Quick Learning · Tutoring · Validated profiles and supervised requests",
  "Impossible de charger les devoirs.": "Unable to load the homework.",
  "Sujet PDF": "PDF paper",
  "Tous les devoirs": "All homework",
  "Aucun énoncé saisi.": "No statement entered.",
  "Corrigé": "Answer key",
  "Aucun corrigé saisi pour ce devoir.": "No answer key entered for this homework.",
  "Aucun barème saisi pour ce devoir.": "No marking scheme entered for this homework.",
  "Devoirs et corrigés": "Homework and answer keys",
  "Énoncés, corrigés et barèmes saisis dans l'administration.": "Statements, answer keys and marking schemes entered in the administration.",
  "Filtrer par manuel": "Filter by textbook",
  "Aucun devoir disponible.": "No homework available.",
  "Corrigé disponible": "Answer key available",
  "Sans corrigé": "No answer key",
  "Tableau de bord élève": "Student dashboard",
  "Abonnement actif": "Subscription active",
  "Expiration": "Expiry",
  "Récent": "Recent",
  "Inconnu": "Unknown",
  "Position GPS": "GPS position",
  "Carte des positions GPS autorisées et des positions approximatives de repli": "Map of authorised GPS positions and approximate fallback positions",
  "Requêtes": "Requests",
  "Moyenne (ms)": "Average (ms)",
  "Aucun point de métrique pour cette période.": "No metric point for this period.",
  "Trafic": "Traffic",
  "Latence API": "API latency",
  "Codes HTTP": "HTTP codes",
  "Accès réservé au superadministrateur.": "Access reserved for the super administrator.",
  "Présences momentanément indisponibles.": "Presence temporarily unavailable.",
  "Santé serveur momentanément indisponible.": "Server health temporarily unavailable.",
  "Historique momentanément indisponible.": "History temporarily unavailable.",
  "Actives": "Active",
  "Disponibles": "Available",
  "Chargement du centre de supervision…": "Loading the supervision centre…",
  "Centre de supervision": "Supervision centre",
  "Vue opérationnelle temps réel · GPS autorisé, ville/région en repli": "Real-time operational view · authorised GPS, city/region as fallback",
  "Heure locale": "Local time",
  "Dernière actualisation": "Last refresh",
  "Actualiser": "Refresh",
  "Les dernières données valides restent affichées.": "The last valid data remains displayed.",
  "récents": "recent",
  "Direction": "Management",
  "CEO, Directeur, administrateurs": "CEO, Director, administrators",
  "Requêtes / min": "Requests / min",
  "Latence P95": "P95 latency",
  "Erreurs 5xx": "5xx errors",
  "État global": "Overall status",
  "Positions en temps réel": "Real-time positions",
  "résultat(s) · précision GPS lorsqu'elle est autorisée": "result(s) · GPS accuracy when authorised",
  "Nom, ville ou zone": "Name, city or area",
  "Rôle": "Role",
  "Tous": "All",
  "Région / ville": "Region / city",
  "GPS soumis à l'autorisation de l'utilisateur": "GPS subject to the user's authorisation",
  "Historique système": "System history",
  "Mesures agrégées, sans contenu utilisateur": "Aggregated measurements, without user content",
  "Période historique": "History period",
  "Présences récentes": "Recent presence",
  "Données de supervision": "Supervision data",
  "Zone": "Area",
  "Ville / région": "City / region",
  "Dernier signal": "Last signal",
  "ACTIVITÉ": "ACTIVITY",
  "Non renseignée": "Not provided",
  "Aucune présence ne correspond aux filtres.": "No presence matches the filters.",
  "Latence moyenne": "Average latency",
  "Requêtes observées": "Requests observed",
  "ÉCHEC": "FAILURE",
  "Latence": "Latency",
  "Connexions actives / max": "Active / max connections",
  "Source Railway fiable non encore configurée.": "Reliable Railway source not configured yet.",
  "Source fiable non configurée": "Reliable source not configured",
  "Alertes": "Alerts",
  "Situation normale": "All normal",
  "Aucune alerte active.": "No active alert.",
  "Signal de supervision": "Supervision signal",
  "occurrence(s)": "occurrence(s)",
  "Activité récente": "Recent activity",
  "Aucune activité récente.": "No recent activity.",
  "Événement": "Event",
  "Rôle inconnu": "Unknown role",
  "Une élève révise avec son manuel Quick Learning": "A student revises with her Quick Learning textbook",
  "Un enseignant génère ses épreuves avec Quick Learning": "A teacher generates tests with Quick Learning",
  "Choisir la photo": "Choose the photo",
  "0 jour": "0 days",
  "Impossible de charger les parrainages.": "Unable to load the referrals.",
  "Dès qu’un filleul paie son abonnement, 10% du nombre de jours souscrits est automatiquement ajouté à l’abonnement de son parrain. Rien à valider — cette page ne sert qu’à suivre les parrainages.": "As soon as a referee pays for their subscription, 10% of the subscribed days is automatically added to their referrer's subscription. Nothing to validate — this page is only for tracking referrals.",
  "Aucun parrainage enregistré.": "No referral recorded.",
  "a parrainé": "referred",
  "ajouté": "added",
  "au parrain": "to the referrer",
  "Mes épreuves": "My tests",
  "Brouillons": "Drafts",
  "Portefeuille": "Wallet",
  "Messagerie": "Messaging",
  "Fiches TD": "Worksheets",
  "Profil soutien": "Tutoring profile",
  "Compte": "Account",
  "Actions de l’espace enseignant": "Teacher space actions",
  "Nouvelle épreuve": "New test",
  "Nouveau": "New",
  "Ouvrir le menu enseignant": "Open the teacher menu",
  "Fermer le menu enseignant": "Close the teacher menu",
  "Navigation du tableau de bord": "Dashboard navigation",
  "Compte enseignant": "Teacher account",
  "MON PORTEFEUILLE": "MY WALLET",
  "Gérer le portefeuille": "Manage the wallet",
  "Bonjour,": "Hello,",
  "Voici un aperçu de votre espace enseignant.": "Here is an overview of your teacher space.",
  "Générateur autorisé": "Authorised generator",
  "Résumé du compte": "Account summary",
  "Épreuves": "Tests",
  "Non lues": "Unread",
  "Profil pédagogique": "Teaching profile",
  "Aucune matière n’est encore associée à ce compte.": "No subject is associated with this account yet.",
  "Accès rapide": "Quick access",
  "Continuer dans l’espace enseignant": "Continue in the teacher space",
  "Sélectionnez une action pour continuer.": "Select an action to continue.",
  "Quick Learning — Espace enseignant": "Quick Learning — Teacher space",
  "Informations": "Information",
  "Prestations et tarifs": "Services and rates",
  "Publication": "Publication",
  "Indiquez le nom affiché.": "Enter the display name.",
  "Indiquez votre établissement ou choisissez « Intervenant indépendant ».": "Enter your school or choose \"Independent tutor\".",
  "Indiquez votre ville.": "Enter your city.",
  "Rédigez votre présentation professionnelle.": "Write your professional introduction.",
  "Choisissez au moins une classe.": "Choose at least one class.",
  "Choisissez au moins une modalité de cours.": "Choose at least one lesson format.",
  "Chaque tarif doit être un nombre positif.": "Each rate must be a positive number.",
  ": indiquez l'heure de début et de fin.": ": enter the start and end time.",
  ": l'heure de fin doit être après l'heure de début.": ": the end time must be after the start time.",
  "Indiquez au moins une plage de disponibilité.": "Enter at least one availability slot.",
  "Aperçu dans l'annuaire": "Preview in the directory",
  "Nom du professeur": "Teacher's name",
  "Tarifs indicatifs": "Indicative rates",
  "Non renseignés (aucun prix affiché aux parents).": "Not provided (no price shown to parents).",
  "Vos coordonnées privées ne sont jamais affichées aux parents.": "Your private contact details are never shown to parents.",
  "Le soutien scolaire n'est pas disponible pour ce compte.": "Tutoring is not available for this account.",
  "Formats acceptés : JPEG, PNG ou WebP.": "Accepted formats: JPEG, PNG or WebP.",
  "La photo ne doit pas dépasser 5 Mo.": "The photo must not exceed 5 MB.",
  "Brouillon enregistré.": "Draft saved.",
  "Confirmez que les informations et tarifs indiqués sont exacts.": "Confirm that the information and rates given are accurate.",
  "Votre profil a été envoyé pour validation. L'administration va l'examiner.": "Your profile has been sent for validation. The administration will review it.",
  "Mon profil de soutien scolaire": "My tutoring profile",
  "Complétez vos informations pour être découvert par les parents. Prévisualisez votre fiche avant de demander sa publication.": "Complete your details to be found by parents. Preview your profile before requesting its publication.",
  "Nouveau profil": "New profile",
  "Sections du profil": "Profile sections",
  "À corriger": "To correct",
  "Informations du professeur": "Teacher information",
  "Nom affiché": "Display name",
  "Photo de profil": "Profile photo",
  "JPEG, PNG ou WebP, 5 Mo maximum.": "JPEG, PNG or WebP, 5 MB maximum.",
  "Statut professionnel": "Professional status",
  "Enseignant en établissement": "Teacher at a school",
  "Établissement": "School",
  "Quartier / zone d'intervention (facultatif)": "Neighbourhood / area covered (optional)",
  "Ex. : Ngoa-Ekellé": "E.g. Ngoa-Ekellé",
  "Présentation professionnelle": "Professional introduction",
  "Matières et classes enseignées": "Subjects and classes taught",
  "Sélectionnez les matières, puis indiquez si vous le souhaitez un tarif horaire pour chacune.": "Select the subjects, then optionally set an hourly rate for each.",
  "Classes prises en charge": "Classes covered",
  "Tarifs horaires (FCFA)": "Hourly rates (FCFA)",
  "Non renseigné": "Not provided",
  "Laissez vide pour ne pas afficher de prix pour cette matière.": "Leave empty to show no price for this subject.",
  "Modalités de cours": "Lesson formats",
  "Disponibilités hebdomadaires": "Weekly availability",
  "Activez les jours où vous êtes disponible et renseignez une plage horaire.": "Turn on the days you are available and enter a time slot.",
  ": début": ": start",
  ": fin": ": end",
  "Validation et publication": "Validation and publication",
  "✓ Votre profil public est approuvé et visible par les parents.": "✓ Your public profile is approved and visible to parents.",
  "Votre profil est en cours d'examen par l'administration.": "Your profile is being reviewed by the administration.",
  "Dernière soumission refusée": "Last submission refused",
  "Profil suspendu": "Profile suspended",
  "Il n'est plus visible des parents.": "It is no longer visible to parents.",
  "Votre version déjà approuvée reste visible par les parents jusqu'à la décision sur vos modifications.": "Your already approved version remains visible to parents until a decision is made on your changes.",
  "« Enregistrer le brouillon » garde vos modifications sans les publier. « Soumettre à validation » les envoie à l'administration ; elles deviennent publiques seulement après approbation.": "\"Save the draft\" keeps your changes without publishing them. \"Submit for validation\" sends them to the administration; they only become public after approval.",
  "Je confirme que les informations et tarifs indiqués sont exacts.": "I confirm that the information and rates given are accurate.",
  "Enregistrer le brouillon": "Save the draft",
  "Soumettre à validation": "Submit for validation",
  "Chargement de votre espace enseignant…": "Loading your teacher space…",
  "Connexion impossible": "Unable to connect",
  "Chargement des Fiches TD…": "Loading worksheets…",
  "Chargement du profil soutien scolaire…": "Loading the tutoring profile…",
  "Chargement des notifications…": "Loading notifications…",
  "Chargement du compte…": "Loading the account…",
  "Adresse du fichier manquante.": "File address missing.",
  "Adresse du fichier invalide.": "Invalid file address.",
  "Téléchargement impossible (": "Download failed (",
  "Le serveur a renvoyé une page HTML au lieu du fichier.": "The server returned an HTML page instead of the file.",
  "Le fichier reçu est vide.": "The file received is empty.",
  "non lu": "unread",
  "Nouveau : pas encore ouvert": "New: not opened yet",
  "Contenus hors connexion verrouillés : connectez-vous à Internet (au moins une fois toutes les 48 h).": "Offline content locked: connect to the Internet (at least once every 48 h).",
  "Votre abonnement est arrivé à échéance : renouvelez-le pour retrouver vos contenus.": "Your subscription has expired: renew it to get your content back.",
  "La date de l'appareil a été reculée : connectez-vous à Internet pour débloquer vos contenus.": "The device date has been set back: connect to the Internet to unlock your content.",
  "Connectez-vous pour activer le mode hors connexion.": "Log in to enable offline mode.",
  "Copie refusée par le serveur.": "Work refused by the server.",
  "Super administrateur": "Super administrator",
  "ESPACE CEO": "CEO SPACE",
  "ESPACE DIRECTEUR": "DIRECTOR SPACE",
  "ESPACE ADMINISTRATEUR": "ADMINISTRATOR SPACE",
  "ESPACE COMMUNITY MANAGER": "COMMUNITY MANAGER SPACE",
  "ESPACE SECRÉTARIAT": "SECRETARIAT SPACE",
  "ESPACE BRAND AMBASSADOR": "BRAND AMBASSADOR SPACE",
  "ESPACE COMPTABLE": "ACCOUNTANT SPACE",
  "ESPACE ENSEIGNANT": "TEACHER SPACE",
  "Impression": "Printing",
  "L’accès au microphone a été refusé.": "Microphone access was refused.",
  "L’accès à la caméra a été refusé.": "Camera access was refused.",
  "L’accès à la caméra ou au microphone a été refusé.": "Camera or microphone access was refused.",
  "Aucune caméra ou aucun microphone compatible n’a été détecté.": "No compatible camera or microphone was detected.",
  "La caméra ou le microphone est déjà utilisé par une autre application.": "The camera or microphone is already used by another app.",
  "La connexion à l’appel a été interrompue.": "The call connection was interrupted.",
  "Impossible d’accéder à la caméra ou au microphone.": "Unable to access the camera or microphone.",
  "Aucun microphone n’a été détecté.": "No microphone was detected.",
  "Le microphone est déjà utilisé par une autre application.": "The microphone is already used by another app.",
  "L’enregistrement audio n’est pas pris en charge sur cet appareil.": "Audio recording is not supported on this device.",
  "L’accès au microphone a été interrompu.": "Microphone access was interrupted.",
  "Une erreur navigateur empêche l’accès au microphone.": "A browser error prevents access to the microphone.",
  "Modification impossible.": "Change not possible.",
  "Assistance · élèves": "Support · students",
  "Questions des élèves, rendus de devoirs et d'évaluations : gérez les demandes qui vous sont adressées.": "Student questions, homework and assessment submissions: manage the requests addressed to you.",
  "Ma disponibilité": "My availability",
  "Nombre d'élèves suivis en même temps": "Number of students followed at the same time",
  "Élèves suivis en même temps": "Students followed at the same time",
  "à la fois": "at a time",
  "Demandes en attente": "Pending requests",
  "Dans votre file": "In your queue",
  "Demandes en cours": "Requests in progress",
  "Prises en charge": "Being handled",
  "Messages non lus": "Unread messages",
  "Des élèves": "From students",
  "Temps médian de traitement": "Median handling time",
  "Sur vos demandes terminées": "On your completed requests",
  "Pas encore assez de demandes terminées": "Not enough completed requests yet",
  "File et conversations": "Queue and conversations",
  "Demandes sur les exercices": "Exercise requests",
  "Écrire à un élève": "Write to a student",
  "Période": "Period",
  "Type de période": "Period type",
  "Mois": "Month",
  "Année": "Year",
  "Intervalle": "Range",
  "Toutes périodes": "All periods",
  "Aucune donnée sur la période.": "No data for the period.",
  "Historique des modifications": "Change history",
  "Aucune modification enregistrée depuis la mise en place de l’historique.": "No change recorded since the history was set up.",
  "Justificatif": "Receipt",
  "Joint": "Attached",
  "Joindre une pièce (PDF ou image)": "Attach a document (PDF or image)",
  "Tableau de bord indisponible.": "Dashboard unavailable.",
  "Salaires versés": "Salaries paid",
  "Autres dépenses": "Other expenses",
  "Tableau de bord comptable": "Accounting dashboard",
  "Revenus, salaires et dépenses réunis dans une vue claire.": "Revenue, salaries and expenses together in one clear view.",
  "Revenus enregistrés": "Recorded revenue",
  "FCFA ·": "FCFA ·",
  "d’apports (hors revenus)": "of contributions (excluding revenue)",
  "FCFA · date effective du versement": "FCFA · effective payment date",
  "Dépenses hors salaires": "Expenses excluding salaries",
  "FCFA · dépenses payées": "FCFA · paid expenses",
  "Solde des opérations": "Operations balance",
  "FCFA · revenus − sorties": "FCFA · revenue − outflows",
  "Évolution des opérations": "Operations over time",
  "Milliers de FCFA": "Thousands of FCFA",
  "À traiter en priorité": "To handle first",
  "Rien à signaler sur cette période.": "Nothing to report for this period.",
  "Cliquez sur une alerte pour ouvrir les opérations concernées.": "Click an alert to open the related operations.",
  "Répartition des revenus": "Revenue breakdown",
  "Par nature": "By type",
  "Dépenses par catégorie": "Expenses by category",
  "Aucune dépense payée sur la période.": "No paid expense for the period.",
  "Dernières opérations": "Latest operations",
  "Aucune opération sur la période.": "No operation for the period.",
  "Libellé": "Label",
  "Apport": "Contribution",
  "Revenu": "Revenue",
  "Salaire": "Salary",
  "Dépense": "Expense",
  "Le solde des opérations n’est ni le bénéfice comptable ni le solde bancaire réel.": "The operations balance is neither the accounting profit nor the actual bank balance.",
  "Les apports sont des encaissements, pas des revenus : ils n’entrent pas dans ce solde.": "Contributions are receipts, not revenue: they are not included in this balance.",
  "✓ Paiement de": "✓ Payment of",
  "FCFA enregistré. Réf :": "FCFA recorded. Ref:",
  "Paiement manuel · fiche de saisie": "Manual payment · entry form",
  "Montant (FCFA) *": "Amount (FCFA) *",
  "Date de l’encaissement": "Receipt date",
  "Méthode de saisie": "Entry method",
  "Paiement manuel": "Manual payment",
  "Portefeuille enseignant": "Teacher wallet",
  "Vente manuel (code)": "Textbook sale (code)",
  "Financement": "Funding",
  "Nature de l’entrée": "Type of entry",
  "Compte de destination": "Destination account",
  "Élève / utilisateur (optionnel)": "Student / user (optional)",
  "Taper un nom…": "Type a name…",
  "Ex. : 12 manuels — établissement partenaire": "E.g. 12 textbooks — partner school",
  "« Paiement manuel » est une méthode de saisie : précisez la nature (abonnement, vente de manuels…). Un apport n’est pas compté comme revenu.": "\"Manual payment\" is an entry method: specify the type (subscription, textbook sale…). A contribution is not counted as revenue.",
  "✓ Fiche enregistrée.": "✓ Form saved.",
  "Supprimer ce paiement manuel ? Cette action est irréversible.": "Delete this manual payment? This action cannot be undone.",
  "Détail du revenu": "Revenue details",
  "Élève / libellé": "Student / label",
  "Méthode": "Method",
  "Référence": "Reference",
  "Informations comptables": "Accounting information",
  "Montant (paiement manuel)": "Amount (manual payment)",
  "Joints": "Attached",
  "À fournir": "To be provided",
  "Non requis": "Not required",
  "Non renseignés": "Not provided",
  "Retrouver chaque entrée, son origine et sa référence.": "Find each entry, its origin and its reference.",
  "Revenus de la période": "Revenue for the period",
  "d’apports": "of contributions",
  "Paiements manuels": "Manual payments",
  "saisie(s)": "entry(ies)",
  "Paiements en ligne et autres": "Online and other payments",
  "FCFA · CinetPay, codes, portefeuille…": "FCFA · CinetPay, codes, wallet…",
  "Opérations enregistrées": "Recorded operations",
  "Sur la période": "Over the period",
  "Rechercher un élève, une référence…": "Search a student, a reference…",
  "Toutes les méthodes": "All methods",
  "Nature": "Type",
  "Toutes les natures": "All types",
  "Tous les justificatifs": "All receipts",
  "opération(s) ·": "operation(s) ·",
  "Aucun revenu correspondant.": "No matching revenue.",
  "Nature des recettes": "Types of income",
  "La nature du revenu est distincte du mode de paiement. Les apports ne sont pas des revenus.": "The type of revenue is separate from the payment method. Contributions are not revenue.",
  "Justificatifs": "Receipts",
  "Aucune opération.": "No operation.",
  "Une pièce jointe passe automatiquement en « Joint ». « Non renseigné » n’est pas « à fournir ».": "An attachment automatically switches to \"Attached\". \"Not provided\" is not \"to be provided\".",
  "Erreur génération bulletin.": "Error generating the payslip.",
  "Supprimer ce versement ?": "Delete this payment?",
  "Versement de salaire": "Salary payment",
  "Ajouter un versement de salaire": "Add a salary payment",
  "Bénéficiaire *": "Beneficiary *",
  "Montant versé (FCFA) *": "Amount paid (FCFA) *",
  "Date du paiement *": "Payment date *",
  "Mois de paie concerné": "Pay month concerned",
  "Compte de paiement": "Payment account",
  "Salaire, avance, complément…": "Salary, advance, top-up…",
  "La sortie de trésorerie suit la date du paiement ; le mois de paie rattache ce versement au salaire prévu. Aucun barème fiscal ou social n’est appliqué.": "The cash outflow follows the payment date; the pay month links this payment to the planned salary. No tax or social scale is applied.",
  "Imprimer le bulletin": "Print the payslip",
  "Supprimer cette prévision ? Les versements sont conservés.": "Delete this forecast? The payments are kept.",
  "Modifier le salaire prévu": "Edit the planned salary",
  "Salaire prévu pour le mois": "Planned salary for the month",
  "Mois de paie *": "Pay month *",
  "Montant net prévu (FCFA) *": "Planned net amount (FCFA) *",
  "Échéance": "Due date",
  "Plusieurs versements peuvent solder ce montant. Le retard n’est signalé que si une échéance est renseignée et dépassée.": "Several payments can settle this amount. Delay is only flagged if a due date is set and passed.",
  "Supprimer la prévision": "Delete the forecast",
  "Montant prévu": "Planned amount",
  "Déjà versé": "Already paid",
  "Reste à payer": "Remaining to pay",
  "Non déterminable": "Cannot be determined",
  "· en retard": "· late",
  "Versé au-delà du prévu": "Paid beyond the planned amount",
  "Modifier le prévu": "Edit the planned amount",
  "Renseigner le prévu": "Enter the planned amount",
  "Ajouter un versement": "Add a payment",
  "Versements de ce mois de paie": "Payments for this pay month",
  "Aucun versement enregistré.": "No payment recorded.",
  "Suivre les bénéficiaires, les versements et les sommes restant dues.": "Track beneficiaries, payments and amounts still due.",
  "FCFA · mois de paie": "FCFA · pay month",
  "bénéficiaire(s) sans prévision non comptés": "beneficiary(ies) without forecast not counted",
  "FCFA · prévu moins versé": "FCFA · planned minus paid",
  "Bénéficiaires à solder": "Beneficiaries to settle",
  "Sur": "Out of",
  "bénéficiaire(s)": "beneficiary(ies)",
  "Rechercher un bénéficiaire…": "Search a beneficiary…",
  "Mois de paie :": "Pay month:",
  "Restant dus": "Remaining due",
  "Payé": "Paid",
  "Partiellement payé": "Partly paid",
  "À payer": "To pay",
  "Prévision non renseignée": "Forecast not provided",
  "Salaire prévu": "Planned salary",
  "Suivi des bénéficiaires ·": "Beneficiary tracking ·",
  "Aucun bénéficiaire pour ce mois de paie. Renseignez un salaire prévu ou un versement.": "No beneficiary for this pay month. Enter a planned salary or a payment.",
  "Bénéficiaire": "Beneficiary",
  "Prévu": "Planned",
  "Versé": "Paid",
  "Restant": "Remaining",
  "versement(s)": "payment(s)",
  "Sans salaire prévu, le reste à payer n’est pas calculé. Statut : à payer, partiellement payé ou payé.": "Without a planned salary, the remaining amount is not calculated. Status: to pay, partly paid or paid.",
  "Versements par mois": "Payments by month",
  "Une fiche par bénéficiaire": "One form per beneficiary",
  "Montant prévu, échéance et versements successifs du mois, réunis dans la fiche « Voir ».": "Planned amount, due date and successive payments of the month, gathered in the \"View\" form.",
  "Versements sans mois de paie reconnu": "Payments without a recognised pay month",
  "Salaire restant dû ≠ solde disponible de l’entreprise.": "Salary still due ≠ the company's available balance.",
  "Versements de la période": "Payments for the period",
  "· date effective ·": "· effective date ·",
  "Sans mois de paie ✕": "No pay month ✕",
  "Aucun versement sur la période.": "No payment for the period.",
  "Mois de paie": "Pay month",
  "Non reconnu": "Not recognised",
  "Montant modifié : la dépense repart en validation.": "Amount changed: the expense goes back for validation.",
  "Modifier la dépense": "Edit the expense",
  "Ajouter une dépense": "Add an expense",
  "Date *": "Date *",
  "Catégorie": "Category",
  "Fournisseur / bénéficiaire": "Supplier / beneficiary",
  "« À valider » envoie la demande d’approbation dans la messagerie des super admins : le CEO à partir de 20 000 FCFA, n’importe quel super admin en dessous.": "\"To validate\" sends the approval request to the super admins' messaging: the CEO from 20,000 FCFA, any super admin below that.",
  "Supprimer cette dépense ?": "Delete this expense?",
  "Détail de la dépense": "Expense details",
  "Date du paiement": "Payment date",
  "Approuvée par": "Approved by",
  "Circuit de validation": "Validation workflow",
  "Renvoyer en brouillon": "Send back to draft",
  "Marquer payée": "Mark as paid",
  "En attente d’approbation par le CEO (dépense ≥ 20 000 FCFA).": "Awaiting approval by the CEO (expense ≥ 20,000 FCFA).",
  "En attente d’approbation par un super admin, depuis sa messagerie.": "Awaiting approval by a super admin, from their messaging.",
  "Erreur lors de la génération du PDF.": "Error while generating the PDF.",
  "Suivre les sorties, leurs catégories et les pièces justificatives.": "Track outflows, their categories and supporting documents.",
  "Dépenses payées": "Paid expenses",
  "FCFA · hors salaires ·": "FCFA · excluding salaries ·",
  "Catégories": "Categories",
  "Justificatifs à fournir": "Receipts to provide",
  "FCFA à documenter": "FCFA to document",
  "Aucune pièce marquée à fournir": "No document marked as to be provided",
  "FCFA · après sorties": "FCFA · after outflows",
  "Rechercher une dépense…": "Search an expense…",
  "Toutes les catégories": "All categories",
  "ligne(s)": "line(s)",
  "Aucune dépense correspondante.": "No matching expense.",
  "Seules les dépenses « Payée » entrent dans les totaux et l’export PDF.": "Only \"Paid\" expenses are included in the totals and the PDF export.",
  "Répartition par catégorie": "Breakdown by category",
  "Validation des dépenses": "Expense validation",
  "Une demande en attente ou approuvée reste distincte des dépenses effectivement payées : elle ne modifie pas les décaissements.": "A pending or approved request remains separate from expenses actually paid: it does not change the disbursements.",
  "Vous pouvez approuver les demandes, ici ou depuis la messagerie.": "You can approve requests here or from the messaging.",
  "Les demandes partent dans la messagerie des super admins : le principal approuve à partir de 20 000 FCFA, n’importe quel super admin en dessous.": "Requests go to the super admins' messaging: the main one approves from 20,000 FCFA, any super admin below that.",
  "février": "February",
  "août": "August",
  "décembre": "December",
  "janv.": "Jan.",
  "févr.": "Feb.",
  "avr.": "Apr.",
  "juil.": "Jul.",
  "sept.": "Sept.",
  "oct.": "Oct.",
  "nov.": "Nov.",
  "déc.": "Dec.",
  "année": "year",
  "à aujourd’hui": "to today",
  "toutes périodes": "all periods",
  "Vente de manuels": "Textbook sales",
  "Prestation": "Service",
  "Banque": "Bank",
  "Caisse": "Cash desk",
  "Hébergement / Serveur": "Hosting / Server",
  "Nom de domaine": "Domain name",
  "Loyer / Local": "Rent / Premises",
  "Entretien / Maintenance": "Upkeep / Maintenance",
  "Marketing / Publicité": "Marketing / Advertising",
  "Événement d'entreprise": "Company event",
  "Équipement / Matériel": "Equipment / Hardware",
  "Logiciel / Abonnement": "Software / Subscription",
  "Transport / Déplacement": "Transport / Travel",
  "Formation du personnel": "Staff training",
  "Fournitures de bureau": "Office supplies",
  "Communication / Téléphonie": "Communication / Telephony",
  "Impression / Reprographie": "Printing / Copying",
  "À valider": "To validate",
  "Approuvée": "Approved",
  "Payée": "Paid",
  "Reversement Brand Ambassador": "Brand Ambassador remittance",
  "Chez l'enseignant": "At the teacher's place",
  "En attente de validation": "Awaiting validation",
  "Connexion impossible. Vérifiez votre réseau puis réessayez.": "Unable to connect. Check your network and try again.",
  "Document téléchargé.": "Document downloaded.",
  "Pagination": "Pagination",
  "résultats": "results",
  "Versement ·": "Payment ·",
  "Tranches encore possibles": "Instalments still possible",
  "Montant reçu (FCFA)": "Amount received (FCFA)",
  "Moyen de paiement": "Payment method",
  "Référence (facultatif)": "Reference (optional)",
  "Numéro de transaction Mobile Money": "Mobile Money transaction number",
  "Justificatif (photo ou PDF, facultatif)": "Receipt (photo or PDF, optional)",
  "Un paiement Mobile Money saisi ici reste « déclaré » jusqu’à son rapprochement par le comptable.": "A Mobile Money payment entered here stays \"declared\" until the accountant reconciles it.",
  "Enregistrer et créer le reçu": "Save and create the receipt",
  "Motif de la contre-écriture du reçu": "Reason for reversing the receipt",
  "Note du rappel (appel, message au parent…) :": "Reminder note (call, message to the parent…):",
  "Annuler cette vente ? L’exemplaire revient dans le stock.": "Cancel this sale? The copy goes back into stock.",
  "Motif de l’annulation :": "Reason for cancellation:",
  "Annuler la vente": "Cancel the sale",
  "Vente": "Sale",
  "Vente introuvable.": "Sale not found.",
  "Manuel remis": "Textbook handed over",
  "Réservé, non remis": "Reserved, not handed over",
  "Code activé": "Code activated",
  "Code non activé": "Code not activated",
  "Parent / tuteur": "Parent / guardian",
  "Prix": "Price",
  "Versé / reste": "Paid / remaining",
  "Ambassadeur": "Ambassador",
  "Échéancier": "Payment schedule",
  "Tranche": "Instalment",
  "réglée": "settled",
  "à payer": "to pay",
  "Versements et reçus": "Payments and receipts",
  "Aucun versement pour le moment.": "No payment yet.",
  "Reçu": "Receipt",
  "Contre-écriture :": "Reversal:",
  "Annulé": "Cancelled",
  "Rapproché": "Reconciled",
  "Déclaré": "Declared",
  "Réf.": "Ref.",
  "le reçu": "the receipt",
  "Rapprocher": "Reconcile",
  "Contre-écriture": "Reversal",
  "Rappels": "Reminders",
  "Manuel remis à l’élève": "Textbook handed to the student",
  "Noter un rappel": "Note a reminder",
  "Enregistrer un versement": "Record a payment",
  "Registre des ventes": "Sales register",
  "Rechercher élève, école, classe ou code": "Search student, school, class or code",
  "État": "State",
  "Toutes les ventes": "All sales",
  "Avec un reste à payer": "With an amount remaining",
  "Partielles": "Partial",
  "Non payées": "Unpaid",
  "Soldées": "Settled",
  "Annulées": "Cancelled",
  "Chargement impossible.": "Unable to load.",
  "Élève / établissement": "Student / school",
  "Reste": "Remaining",
  "Aucune vente ne correspond.": "No matching sale.",
  "Aucune vente enregistrée.": "No sale recorded.",
  "vente(s) · montant total": "sale(s) · total amount",
  "Suivez vos ventes et vos encaissements.": "Track your sales and your receipts.",
  "＋ Nouvelle vente": "＋ New sale",
  "📚 Manuels reçus": "📚 Textbooks received",
  "disponible(s)": "available",
  "🛍️ Manuels vendus": "🛍️ Textbooks sold",
  "remis à des élèves": "handed to students",
  "💰 Encaissements": "💰 Receipts",
  "à rapprocher": "to reconcile",
  "Versements des élèves": "Student payments",
  "⏳ Soldes à recouvrer": "⏳ Balances to collect",
  "élève(s) en retard": "student(s) late",
  "Dernières ventes": "Latest sales",
  "Tout afficher →": "Show all →",
  "Aucune vente pour le moment.": "No sale yet.",
  "Actions rapides": "Quick actions",
  "Nouvelle vente →": "New sale →",
  "Enregistrer un versement →": "Record a payment →",
  "Voir mon stock →": "See my stock →",
  "Reverser à la comptabilité →": "Remit to accounting →",
  "⏰ Retards de paiement": "⏰ Late payments",
  "· reste": "· remaining",
  "Aucun retard. 👍": "No delays. 👍",
  "À reverser à la comptabilité :": "To remit to accounting:",
  "Identifiez l’élève et le manuel de votre stock.": "Identify the student and the textbook from your stock.",
  "Le prix est celui fixé par la direction. La remise physique du manuel et l’activation du code par l’élève sont deux étapes distinctes.": "The price is the one set by management. Handing over the physical textbook and the student activating the code are two separate steps.",
  "Exemplaire (code manuel de votre stock) *": "Copy (textbook code from your stock) *",
  "Choisir un code": "Choose a code",
  "Aucun exemplaire disponible dans votre stock": "No copy available in your stock",
  "Nom et prénom de l’élève *": "Student's full name *",
  "Ex. Nadia M.": "E.g. Nadia M.",
  "Établissement *": "School *",
  "Ex. Lycée de …": "E.g. Lycée de …",
  "Classe *": "Class *",
  "Paiement en": "Payment in",
  "1 tranche (comptant)": "1 instalment (cash)",
  "2 tranches": "2 instalments",
  "3 tranches": "3 instalments",
  "Date de la tranche": "Instalment date",
  "Téléphone du parent ou tuteur (facultatif)": "Parent or guardian's phone (optional)",
  "Le parent ou tuteur accepte que ce contact soit enregistré": "The parent or guardian agrees to this contact being recorded",
  "Manuel remis à l’élève dès maintenant": "Textbook handed to the student now",
  "Premier versement (facultatif)": "First payment (optional)",
  "Montant (FCFA)": "Amount (FCFA)",
  "Numéro de transaction": "Transaction number",
  "Manuel :": "Textbook:",
  "Enregistrer la vente": "Save the sale",
  "Retrouvez toutes les ventes enregistrées, imprimez votre relevé.": "Find all recorded sales and print your statement.",
  "Enregistrez les paiements échelonnés (trois tranches au plus) et imprimez les reçus.": "Record instalment payments (three at most) and print the receipts.",
  "Chaque versement est lié à une vente, ne peut pas dépasser le solde et reçoit un reçu numéroté. Une erreur se corrige par la comptabilité, jamais par une suppression.": "Each payment is linked to a sale, cannot exceed the balance and gets a numbered receipt. A mistake is corrected by accounting, never by deletion.",
  "Ventes avec un reste à payer": "Sales with an amount remaining",
  "Identifiez les soldes restant à payer et notez vos rappels.": "Identify the balances still to be paid and note your reminders.",
  "Élèves en retard de paiement": "Students late in paying",
  "Retirer le code": "Remove the code",
  "de la liste de": "from the list of",
  "? Il redeviendra libre.": "? It will become free again.",
  "Transférer": "Transfer",
  "vers :": "to:",
  "Numéro :": "Number:",
  "Manuels confiés": "Textbooks entrusted",
  "la liste": "the list",
  "Rechercher un code ou un manuel": "Search a code or a textbook",
  "Tous les états": "All states",
  "État physique": "Physical state",
  "État numérique": "Digital state",
  "Liste": "List",
  "Activé le": "Activated on",
  "Code saisi par erreur": "Code entered by mistake",
  "Changer l’état": "Change the state",
  "État…": "State…",
  "Retourné": "Returned",
  "Endommagé": "Damaged",
  "Perdu": "Lost",
  "Aucun manuel dans cette liste.": "No textbook in this list.",
  "La liste de vos manuels est établie par la direction, la comptabilité, le secrétariat ou la CM : elle est la même pour tous.": "Your list of textbooks is drawn up by management, accounting, the secretariat or the CM: it is the same for everyone.",
  "Remettez les sommes encaissées à Quick Learning ; la comptabilité valide chaque bordereau.": "Hand the collected sums to Quick Learning; accounting validates each slip.",
  "＋ Nouveau bordereau": "＋ New slip",
  "Encaissements et reversements": "Receipts and remittances",
  "Encaissements enregistrés": "Recorded receipts",
  "Reversements validés": "Validated remittances",
  "Reversements en attente de validation": "Remittances awaiting validation",
  "Reste à reverser": "Remaining to remit",
  "Dont": "Of which",
  "de paiements Mobile Money encore à rapprocher par le comptable.": "of Mobile Money payments still to be reconciled by the accountant.",
  "Comment faire ?": "How does it work?",
  "Enregistrez chaque versement d’élève et donnez-lui son reçu.": "Record each student payment and give them their receipt.",
  "Remettez l’argent à Quick Learning et créez un bordereau avec la preuve.": "Hand the money to Quick Learning and create a slip with the proof.",
  "La comptabilité valide le bordereau ; il entre dans les revenus.": "Accounting validates the slip; it is added to revenue.",
  "Mes bordereaux": "My slips",
  "Bordereau": "Slip",
  "Preuve": "Proof",
  "Rejeter": "Reject",
  "Aucun bordereau.": "No slip.",
  "Preuve de reversement": "Proof of remittance",
  "Nouveau bordereau de reversement": "New remittance slip",
  "Montant reversé (FCFA)": "Amount remitted (FCFA)",
  "Virement": "Bank transfer",
  "Référence (n° de transaction, de reçu…)": "Reference (transaction no., receipt no.…)",
  "Preuve (photo ou PDF)": "Proof (photo or PDF)",
  "Soumettre à la comptabilité": "Submit to accounting",
  "Suivez le nombre de manuels vendus.": "Track the number of textbooks sold.",
  "mon relevé": "my statement",
  "Manuels vendus": "Textbooks sold",
  "Ventes non annulées": "Sales not cancelled",
  "Manuels remis": "Textbooks handed over",
  "Aux élèves": "To students",
  "Encaissé": "Collected",
  "Stock disponible": "Available stock",
  "reçus": "received",
  "Ventes par mois": "Sales by month",
  "Pas encore de vente.": "No sale yet.",
  "Les commissions éventuelles sont calculées uniquement selon un barème validé par la direction.": "Any commissions are calculated only according to a scale validated by management.",
  "Impossible de charger les codes libres de ce manuel.": "Unable to load the free codes of this textbook.",
  "Nouvelle liste de manuels confiés": "New list of entrusted textbooks",
  "Prendre des codes libres d’un manuel": "Take free codes from a textbook",
  "Saisir ou coller les codes": "Enter or paste the codes",
  "Nombre d’exemplaires": "Number of copies",
  "code(s) libre(s) (ni activé ni déjà confié) pour ce manuel.": "free code(s) (neither activated nor already entrusted) for this textbook.",
  "Codes manuels (un par ligne ou séparés par des virgules)": "Textbook codes (one per line or separated by commas)",
  "Note (facultatif)": "Note (optional)",
  "Un code déjà activé par un élève ou déjà confié à un autre ambassadeur est refusé. La liste apparaît aussitôt chez l’ambassadeur et dans tous les espaces.": "A code already activated by a student or already entrusted to another ambassador is refused. The list appears immediately for the ambassador and in all spaces.",
  "Établir la liste": "Draw up the list",
  "Listes établies": "Lists drawn up",
  "Exemplaires": "Copies",
  "Établie par": "Drawn up by",
  "Aucune liste établie.": "No list drawn up.",
  "Motif du rejet :": "Reason for rejection:",
  "Bordereaux à valider": "Slips to validate",
  "Un bordereau validé entre dans les revenus (« Vente de manuels »).": "A validated slip is added to revenue (\"Textbook sales\").",
  "Paiements Mobile Money à rapprocher": "Mobile Money payments to reconcile",
  "Rien à rapprocher.": "Nothing to reconcile.",
  "· réf.": "· ref.",
  "Accès impossible.": "Access not possible.",
  "Listes des manuels confiés (avec leurs codes), ventes et versements de chaque ambassadeur.": "Lists of entrusted textbooks (with their codes), sales and payments of each ambassador.",
  "＋ Nouvelle liste de manuels": "＋ New list of textbooks",
  "Aucun Brand Ambassador inscrit. Le CEO ou un administrateur crée un code dans « Codes Ambassadeurs » ; l’ambassadeur s’inscrit avec ce code.": "No Brand Ambassador registered. The CEO or an administrator creates a code in \"Ambassador codes\"; the ambassador signs up with that code.",
  "Ambassadeurs": "Ambassadors",
  "Vendus": "Sold",
  "Total versé par les élèves": "Total paid by students",
  "Reversé (validé)": "Remitted (validated)",
  "À reverser": "To remit",
  "Compte inactif": "Inactive account",
  "Manuels vendus par": "Textbooks sold by",
  "établie :": "drawn up:",
  "exemplaire(s).": "copy(ies).",
  "Site Quick Learning": "Quick Learning website",
  "Visuel": "Visual",
  "Carrousel": "Carousel",
  "Texte": "Text",
  "Formulaire du site": "Website form",
  "Transmise au support": "Sent to support",
  "Clôturée": "Closed",
  "Non calculable": "Cannot be calculated",
  "Le titre est obligatoire.": "The title is required.",
  "Modification importante : la validation est annulée. Soumettez de nouveau le contenu.": "Major change: the validation is cancelled. Submit the content again.",
  "Contenu envoyé aux super admins pour validation.": "Content sent to the super admins for validation.",
  "Modifier le contenu": "Edit the content",
  "Préparer un contenu": "Prepare content",
  "Ce contenu est validé : modifier le texte, le média ou le lien annulera la validation.": "This content is validated: changing the text, media or link will cancel the validation.",
  "Canal": "Channel",
  "Format": "Format",
  "Campagne": "Campaign",
  "Aucune": "None",
  "Date souhaitée (heure du Cameroun)": "Desired date (Cameroon time)",
  "Texte proposé": "Proposed text",
  "Visuel, vidéo ou PDF (25 Mo max.)": "Visual, video or PDF (25 MB max.)",
  "Actuel :": "Current:",
  "Texte alternatif du visuel": "Alternative text for the visual",
  "Lien cible": "Target link",
  "Paramètres de campagne": "Campaign settings",
  "Enregistrer et faire valider": "Save and submit for validation",
  "Aucune action enregistrée.": "No action recorded.",
  "Ouvrir le document": "Open the document",
  "Supprimer ce brouillon ?": "Delete this draft?",
  "Date souhaitée": "Desired date",
  "Préparé par": "Prepared by",
  "Publié le": "Published on",
  "Aucun texte.": "No text.",
  "Publication :": "Publication:",
  "Enregistrer la publication réelle": "Record the actual publication",
  "Adresse de la publication": "Publication address",
  "Date réelle (vide = maintenant)": "Actual date (empty = now)",
  "La publication sur le réseau se fait à la main ; Quick Learning n'envoie rien aux réseaux sociaux.": "Posting on the network is done manually; Quick Learning sends nothing to social networks.",
  "Envoyé dans la messagerie des super admins : en attente de leur décision.": "Sent to the super admins' messaging: awaiting their decision.",
  "Correction attendue (pour « Demander une correction »)": "Expected correction (for \"Request a correction\")",
  "Contenu envoyé pour validation.": "Content sent for validation.",
  "Faire valider": "Submit for validation",
  "Publication enregistrée.": "Publication recorded.",
  "Marquer comme publié": "Mark as published",
  "Lien copié.": "Link copied.",
  "Autre (affiche, SMS…)": "Other (poster, SMS…)",
  "Lien général": "General link",
  "inscr.": "sign-ups",
  "QR code du lien": "QR code of the link",
  "+ Lien pour ce réseau": "+ Link for this network",
  "✓ Campagne créée.": "✓ Campaign created.",
  "Supprimer la campagne «": "Delete the campaign \"",
  "Campagnes": "Campaigns",
  "publiés": "published",
  "Aucune campagne.": "No campaign.",
  "Nouvelle campagne": "New campaign",
  "Ex : visites du site": "E.g. website visits",
  "Public visé": "Target audience",
  "Ex : élèves et parents": "E.g. students and parents",
  "Message clé": "Key message",
  "Créer la campagne": "Create the campaign",
  "Atelier des contenus": "Content workshop",
  "Préparer les textes et visuels, puis les faire valider.": "Prepare texts and visuals, then submit them for validation.",
  "Rechercher un contenu, un thème…": "Search content, a theme…",
  "Rechercher un contenu": "Search content",
  "Statut du contenu": "Content status",
  "+ Préparer un contenu": "+ Prepare content",
  "Aucun contenu": "No content",
  "ne correspond à ces critères": "matches these criteria",
  "pour l’instant": "yet",
  "Apprendre n’a jamais été aussi aisé": "Learning has never been so easy",
  "Date non fixée": "Date not set",
  "Ouvrir la fiche": "Open the form",
  "Validation avant diffusion": "Validation before publication",
  "Un contenu soumis arrive dans la messagerie des super admins. Une modification du texte, du média ou du lien d’un contenu validé relance la validation.": "Submitted content arrives in the super admins' messaging. Changing the text, media or link of validated content restarts the validation.",
  "Organiser les contenus, leurs dates et leur validation.": "Organise content, its dates and its validation.",
  "Semaine précédente": "Previous week",
  "Semaine suivante": "Next week",
  "Horaires Cameroun · UTC+1": "Cameroon time · UTC+1",
  "Aucune publication prévue": "No publication planned",
  "À retenir": "Key points",
  "prévue": "planned",
  "dans la semaine,": "this week,",
  "déjà publiée": "already published",
  "Une date prévue ne déclenche pas une publication automatique.": "A planned date does not trigger an automatic publication.",
  "Un circuit partagé": "A shared workflow",
  "Community Manager : prépare": "Community Manager: prepares",
  "Super admin : valide": "Super admin: validates",
  "CM : publie et enregistre le lien": "CM: publishes and records the link",
  "La date souhaitée et la date de publication réelle sont conservées séparément.": "The desired date and the actual publication date are kept separately.",
  "(réf.": "(ref.",
  "Envoi impossible. Vérifiez votre connexion.": "Sending failed. Check your connection.",
  "Écrire à l'équipe": "Write to the team",
  "Nous contacter": "Contact us",
  "Votre nom": "Your name",
  "E-mail ou téléphone": "Email or phone",
  "Ne communiquez ni mot de passe ni code de manuel dans ce message.": "Do not share any password or textbook code in this message.",
  ", voici tes priorités": ", here are your priorities",
  "Préparer les contenus, animer la communauté et suivre les résultats.": "Prepare content, lead the community and track results.",
  "Contenus prévus cette semaine": "Content planned this week",
  "publié": "published",
  "à publier": "to publish",
  "Décision d’un super admin": "Super admin decision",
  "Demandes à traiter": "Requests to handle",
  "en cours": "in progress",
  "Visites issues des campagnes": "Visits from campaigns",
  "Cette semaine ·": "This week ·",
  "Suivi non configuré": "Tracking not configured",
  "À faire aujourd’hui": "To do today",
  "Rien d’urgent aujourd’hui.": "Nothing urgent today.",
  "CAMPAGNE DU MOMENT": "CURRENT CAMPAIGN",
  "Objectif :": "Goal:",
  "Public :": "Audience:",
  "contenus publiés": "published contents",
  "Voir les contenus": "See the content",
  "Campagne du moment": "Current campaign",
  "Aucune campagne en cours. Créez-en une depuis l’atelier des contenus (bouton « Campagnes »).": "No campaign in progress. Create one from the content workshop (\"Campaigns\" button).",
  "Prochaines publications": "Upcoming publications",
  "Aucune publication programmée.": "No publication scheduled.",
  "Aujourd’hui": "Today",
  "Voir le calendrier": "See the calendar",
  "Suivi de la communauté": "Community follow-up",
  "Nouvelles demandes": "New requests",
  "Demandes transmises au support": "Requests sent to support",
  "Les problèmes de paiement et de code de manuel sont confiés au support (super admins).": "Payment and textbook code problems are handed to support (super admins).",
  "Demande introuvable.": "Request not found.",
  "Demande": "Request",
  "dans sa messagerie Quick Learning": "in their Quick Learning messaging",
  "par e-mail": "by email",
  "à la main (": "manually (",
  "Échanges": "Exchanges",
  "Aucun échange pour l’instant.": "No exchange yet.",
  "Réponse enregistrée": "Saved reply",
  "Insérer une réponse enregistrée…": "Insert a saved reply…",
  "Votre réponse ou votre note — relisez avant d’envoyer.": "Your reply or note — reread before sending.",
  "La réponse sera transmise": "The reply will be sent",
  "Réponse enregistrée.": "Reply saved.",
  "Répondre": "Reply",
  "Note interne": "Internal note",
  "Demande transmise aux super admins.": "Request sent to the super admins.",
  "Transmettre au support": "Send to support",
  "Clôturer": "Close",
  "Saisir une demande reçue": "Enter a received request",
  "Nom ou pseudo": "Name or nickname",
  "Contact utile (facultatif)": "Useful contact (optional)",
  "Message reçu": "Message received",
  "Ne notez que les coordonnées nécessaires pour répondre.": "Only note the contact details needed to reply.",
  "Supprimer «": "Delete \"",
  "Réponses enregistrées": "Saved replies",
  "Aucune réponse type.": "No standard reply.",
  "+ Ajouter": "+ Add",
  "Modèle à adapter avant chaque envoi.": "Template to adapt before each sending.",
  "Nouvelle réponse type": "New standard reply",
  "Répondre, orienter les demandes et transmettre au support ce qui le concerne.": "Reply, direct requests and send support-related ones to support.",
  "+ Saisir une demande": "+ Enter a request",
  "À prendre en charge": "To take on",
  "Réponse à compléter": "Reply to complete",
  "Transmises au support": "Sent to support",
  "Paiement, code, compte…": "Payment, code, account…",
  "Clôturées cette semaine": "Closed this week",
  "Depuis lundi": "Since Monday",
  "File de suivi": "Follow-up queue",
  "Rechercher une demande…": "Search a request…",
  "Aucune demande.": "No request.",
  "Des droits précis": "Precise permissions",
  "Les demandes arrivent du formulaire « Nous contacter » du site et de l’application, ou sont saisies ici quand elles viennent des réseaux sociaux.": "Requests come from the \"Contact us\" form of the website and the app, or are entered here when they come from social networks.",
  "Aucun accès aux conversations privées des élèves, aux paiements, aux codes ni à la comptabilité. Les problèmes de paiement ou de code sont transmis au support.": "No access to students' private conversations, payments, codes or accounting. Payment or code problems are sent to support.",
  "Saisie manuelle": "Manual entry",
  "Modifier une saisie": "Edit an entry",
  "Saisir des statistiques": "Enter statistics",
  "Début de la période": "Start of the period",
  "Fin de la période": "End of the period",
  "Impressions (affichages)": "Impressions (views)",
  "Interactions (réactions, commentaires, partages)": "Interactions (reactions, comments, shares)",
  "Clics sur les liens (déclarés par le réseau)": "Link clicks (reported by the network)",
  "Laissez vide une valeur inconnue : elle ne sera pas comptée comme zéro. Une période est rattachée au mois de son début.": "Leave an unknown value empty: it will not be counted as zero. A period is attached to the month it starts in.",
  "Rapport téléchargé.": "Report downloaded.",
  "Rapport d’activité ·": "Activity report ·",
  "Rapport indisponible.": "Report unavailable.",
  "Publications": "Publications",
  "Impressions": "Impressions",
  "Interactions": "Interactions",
  "Demandes reçues / clôturées": "Requests received / closed",
  "Contenus en préparation": "Content in preparation",
  "brouillons ·": "drafts ·",
  "à valider ·": "to validate ·",
  "validés": "validated",
  "Contenus publiés": "Published content",
  "Aucune publication enregistrée ce mois-ci.": "No publication recorded this month.",
  "Difficultés rencontrées": "Difficulties encountered",
  "Priorités du mois suivant": "Priorities for next month",
  "Télécharger (PDF)": "Download (PDF)",
  "Supprimer cette saisie ?": "Delete this entry?",
  "Statistiques & rapports": "Statistics & reports",
  "Comprendre quels contenus attirent et aident les élèves.": "Understand which content attracts and helps students.",
  "Aperçu du rapport": "Report preview",
  "+ Saisir": "+ Enter",
  "Mois en cours : les chiffres sont partiels.": "Current month: the figures are partial.",
  "Publications du mois": "Publications this month",
  "Contenus enregistrés comme publiés": "Content recorded as published",
  "Affichages, pas personnes uniques": "Views, not unique people",
  "Réactions, commentaires, partages": "Reactions, comments, shares",
  "Taux d’engagement": "Engagement rate",
  "Interactions ÷ impressions": "Interactions ÷ impressions",
  "Impressions par période saisie": "Impressions per entered period",
  "Aucune statistique saisie pour": "No statistics entered for",
  "* Période en cours : observation partielle.": "* Current period: partial observation.",
  "Du contenu à la plateforme": "From content to the platform",
  "Clics sur les liens (déclarés par les réseaux)": "Link clicks (reported by the networks)",
  "Visites attribuées": "Attributed visits",
  "Inscriptions attribuées": "Attributed sign-ups",
  "Taux de conversion": "Conversion rate",
  "Visites": "Visits",
  "Inscriptions": "Sign-ups",
  "Conversion": "Conversion",
  "Seuls les visiteurs passés par un lien de suivi de campagne sont comptés (une visite par personne, par lien et par jour) ; une inscription est attribuée si le compte est créé dans les 30 jours. Ce sont des minimums mesurés, rien n’est estimé.": "Only visitors who came through a campaign tracking link are counted (one visit per person, per link and per day); a sign-up is attributed if the account is created within 30 days. These are measured minimums; nothing is estimated.",
  "Résultats par canal": "Results by channel",
  "Engagement": "Engagement",
  "Saisies": "Entries",
  "Aucune donnée ce mois-ci.": "No data this month.",
  "Saisies du mois": "Entries this month",
  "Rien n’a été saisi.": "Nothing has been entered.",
  "Statistiques saisies à la main depuis les réseaux : aucune synchronisation automatique dans cette version.": "Statistics entered manually from the networks: no automatic synchronisation in this version.",
  "À approuver": "To approve",
  "Retirer l’approbation": "Withdraw the approval",
  "Ressources approuvées": "Approved resources",
  "En attente d’approbation": "Awaiting approval",
  "Logos, couvertures et modèles approuvés, distincts des brouillons.": "Approved logos, covers and templates, separate from drafts.",
  "+ Ajouter une ressource": "+ Add a resource",
  "Aucune.": "None.",
  "Une ressource ajoutée par la Community Manager reste « à approuver » jusqu’à la décision du CEO.": "A resource added by the Community Manager stays \"to approve\" until the CEO decides.",
  "Ajouter une ressource": "Add a resource",
  "Fichier (image, vidéo ou PDF, 25 Mo max.)": "File (image, video or PDF, 25 MB max.)",
  "Texte validé (slogan, description…)": "Validated text (slogan, description…)",
  "Suivez vos priorités et les tâches confiées par la direction.": "Track your priorities and the tasks entrusted by management.",
  "Nouvelle tâche": "New task",
  "Tâche": "Task",
  "Organisez les rendez-vous et réunions de Quick Learning.": "Organise Quick Learning's appointments and meetings.",
  "Nouveau rendez-vous": "New appointment",
  "Objet du rendez-vous": "Purpose of the appointment",
  "Date et heure": "Date and time",
  "Service concerné": "Department concerned",
  "Avec": "With",
  "Suivez les prospects, les partenaires et les relances.": "Track prospects, partners and follow-ups.",
  "Nouvel établissement": "New school",
  "Nom de l’établissement": "School name",
  "Contact professionnel": "Professional contact",
  "Prochaine relance": "Next follow-up",
  "Commandes de manuels": "Textbook orders",
  "Suivi administratif des demandes et commandes, sans aucun paiement.": "Administrative tracking of requests and orders, without any payment.",
  "Nouvelle commande": "New order",
  "Demandeur (famille, établissement…)": "Requester (family, school…)",
  "Personne à contacter": "Contact person",
  "Livraison souhaitée": "Desired delivery",
  "Enregistrez, classez et transmettez les courriers entrants et sortants.": "Record, file and forward incoming and outgoing mail.",
  "Enregistrer un courrier": "Record a letter",
  "Objet": "Subject",
  "Référence du courrier": "Letter reference",
  "Expéditeur ou destinataire": "Sender or recipient",
  "Date de réponse attendue": "Expected reply date",
  "Préparez des documents soumis à la validation du CEO avant leur émission.": "Prepare documents submitted to the CEO for validation before they are issued.",
  "Nouveau document": "New document",
  "Titre du document": "Document title",
  "Type (convocation, compte rendu, attestation…)": "Type (notice of meeting, minutes, certificate…)",
  "Contenu": "Content",
  "Priorité": "Priority",
  "Confier à": "Entrust to",
  "Nom du contact": "Contact name",
  "E-mail ou téléphone professionnel": "Professional email or phone",
  "Sens": "Direction",
  "Pièce jointe": "Attachment",
  "Haute": "High",
  "Normale": "Normal",
  "Basse": "Low",
  "Personne": "Nobody",
  "(moi)": "(me)",
  "Courrier entrant": "Incoming mail",
  "Courrier sortant": "Outgoing mail",
  "À préciser": "To be specified",
  "Informations administratives non sensibles": "Non-sensitive administrative information",
  "(remplace l’actuelle)": "(replaces the current one)",
  "Ce document est validé : l’enregistrer à nouveau le ramène au brouillon, à faire valider.": "This document is validated: saving it again sends it back to draft, to be validated.",
  "Dossier introuvable.": "File not found.",
  "Ville / lieu": "City / place",
  "Confié à": "Entrusted to",
  "Créé par": "Created by",
  "Ouvrir la pièce jointe": "Open the attachment",
  "Étapes du document": "Document stages",
  "Émis": "Issued",
  "Archivé": "Archived",
  "Note de suivi ou commentaire": "Follow-up note or comment",
  "Note interne (visible par l’équipe du secrétariat)": "Internal note (visible to the secretariat team)",
  "Enregistrer la note": "Save the note",
  "Envoyer à la validation": "Send for validation",
  "Écrivez d’abord ce qu’il faut corriger": "First write what needs to be corrected",
  "Marquer comme émis": "Mark as issued",
  "Archiver": "Archive",
  "Manuel à préciser": "Textbook to be specified",
  "Registre ·": "Register ·",
  "Rechercher dans cette liste…": "Search this list…",
  "En cours (non clos)": "In progress (not closed)",
  "Toutes priorités": "All priorities",
  "Aucun dossier ne correspond à ces filtres.": "No file matches these filters.",
  "Aucun dossier pour le moment.": "No file yet.",
  "Un document passe par brouillon → validation du CEO → émission → archivage. Aucune signature n’est apposée automatiquement : les communiqués et factures signés se rédigent dans la": "A document goes through draft → CEO validation → issue → archiving. No signature is added automatically: signed announcements and invoices are written in the",
  "Le tableau de bord n’a pas pu être chargé.": "The dashboard could not be loaded.",
  "Voici les activités administratives de Quick Learning pour aujourd’hui.": "Here are Quick Learning's administrative activities for today.",
  "Voir les demandes": "See the requests",
  "Demandes à examiner": "Requests to review",
  "en cours de traitement": "being processed",
  "Messagerie de l’équipe": "Team messaging",
  "Rendez-vous à venir": "Upcoming appointments",
  "Agenda du secrétariat": "Secretariat calendar",
  "Tâches à effectuer": "Tasks to do",
  "Non terminées": "Not completed",
  "Demandes récentes": "Recent requests",
  "Aucune demande en attente.": "No pending request.",
  "Répondre aux messages →": "Reply to messages →",
  "Programmer un rendez-vous →": "Schedule an appointment →",
  "Enregistrer un courrier →": "Record a letter →",
  "Rédiger un communiqué ou une facture →": "Write an announcement or an invoice →",
  "📌 Priorités du jour": "📌 Today's priorities",
  "Échéance :": "Due:",
  "Aucune tâche urgente aujourd’hui.": "No urgent task today.",
  "📅 Prochains rendez-vous": "📅 Upcoming appointments",
  "Aucun rendez-vous programmé.": "No appointment scheduled.",
  "Ouvrir l’agenda": "Open the calendar",
  "À suivre": "To follow",
  "Documents en attente de validation": "Documents awaiting validation",
  "Courriers à traiter": "Mail to process",
  "Établissements à relancer": "Schools to follow up",
  "Commandes de manuels en cours": "Textbook orders in progress",
  "Contacts des parents inscrits et suivi de leurs demandes de soutien scolaire.": "Contacts of registered parents and follow-up of their tutoring requests.",
  "Demandes de soutien": "Tutoring requests",
  "Inscrit le": "Registered on",
  "· dernière :": "· last:",
  "Retrouvez les enseignants et orientez les demandes de soutien.": "Find teachers and direct tutoring requests.",
  "Enseignant de la plateforme": "Platform teacher",
  "La validation des profils enseignants reste au super administrateur : cette liste est en lecture seule.": "Teacher profile validation remains with the super administrator: this list is read-only.",
  "Recherchez un élève pour répondre à une demande d’assistance.": "Search a student to answer a support request.",
  "Demandes au secrétariat": "Requests to the secretariat",
  "Consultation restreinte : seules les informations utiles au secrétariat sont affichées (ni e-mail, ni mot de passe, ni code, ni paiement).": "Restricted view: only information useful to the secretariat is shown (no email, password, code or payment).",
  "Rechercher par nom, ville, école…": "Search by name, city, school…",
  "Aucun résultat pour cette recherche.": "No results for this search.",
  "Aucune personne inscrite pour le moment.": "Nobody registered yet.",
  "Suivez les demandes et commandes de manuels sans modifier les paiements.": "Track textbook requests and orders without changing payments.",
  "Le secrétariat suit les commandes ; les paiements, les prix et les codes d’activation restent gérés par la direction et la comptabilité.": "The secretariat tracks orders; payments, prices and activation codes remain managed by management and accounting.",
  "Catalogue des manuels": "Textbook catalogue",
  "Niveau": "Level",
  "Commandes en cours": "Orders in progress",
  "Non publié": "Not published",
  "Aucun manuel.": "No textbook.",
  "Préférences et informations professionnelles du secrétariat.": "Preferences and professional information of the secretariat.",
  "Profil professionnel": "Professional profile",
  "Identifiant": "Username",
  "Modifier mon profil et mon mot de passe": "Edit my profile and my password",
  "Ma signature": "My signature",
  "Les notifications (nouvelle demande du site, document validé, dossier confié…) arrivent dans la cloche en haut de l’écran.": "Notifications (new website request, validated document, entrusted file…) arrive in the bell at the top of the screen.",
  "🔐 Mes droits": "🔐 My permissions",
  "Traiter les demandes du site avec la Community Manager": "Handle website requests with the Community Manager",
  "Tenir l’agenda, les tâches, les courriers et les commandes de manuels": "Keep the calendar, tasks, mail and textbook orders",
  "Préparer des documents et les envoyer à la validation du CEO": "Prepare documents and send them to the CEO for validation",
  "Rédiger des communiqués et des factures dans la boîte de dépôt": "Write announcements and invoices in the drop box",
  "Échanger avec toute l’équipe dans la messagerie": "Chat with the whole team in the messaging",
  "Valider un profil enseignant, rembourser, modifier un tarif ou un paiement": "Validate a teacher profile, refund, change a rate or a payment",
  "Voir les mots de passe, les codes manuels ou la comptabilité": "See passwords, textbook codes or accounting",
  "Émettre un document sans validation": "Issue a document without validation",
  "Les droits d’accès sont définis par l’administration.": "Access rights are set by the administration.",
  "Impossible de charger la messagerie.": "Unable to load the messaging.",
  "Le message n’a pas pu être envoyé.": "The message could not be sent.",
  "Chargement de vos messages…": "Loading your messages…",
  "Conversations avec l’administration": "Conversations with the administration",
  "Aucune conversation. Votre premier message ouvrira une demande auprès de l’administration.": "No conversation. Your first message will open a request with the administration.",
  "Écrivez à l’administration pour démarrer la conversation.": "Write to the administration to start the conversation.",
  "Vous": "You",
  "Impossible de charger les établissements.": "Unable to load the schools.",
  "Impossible d’enregistrer l’établissement.": "Unable to save the school.",
  "Mes établissements": "My schools",
  "Chargement des établissements…": "Loading schools…",
  "Aucun établissement enregistré.": "No school recorded.",
  "Adresse non renseignée": "Address not provided",
  "Établissement partagé": "Shared school",
  "Modifier l’établissement": "Edit the school",
  "Ajouter un établissement": "Add a school",
  "Nom de l’établissement *": "School name *",
  "Adresse (optionnel)": "Address (optional)",
  "Tutelle / Diocèse / Congrégation (optionnel)": "Supervising body / Diocese / Congregation (optional)",
  "Logo (optionnel)": "Logo (optional)",
  "Correction -": "Correction -",
  "Fiche TD -": "Worksheet -",
  "Fiche TD générée une seule fois. Le téléchargement sera disponible après paiement.": "Worksheet generated only once. The download will be available after payment.",
  "Fiche TD générée et paiement portefeuille confirmé.": "Worksheet generated and wallet payment confirmed.",
  "Paiement confirmé. Votre fiche TD est disponible.": "Payment confirmed. Your worksheet is available.",
  "Checkout CinetPay ouvert. La vérification continue uniquement par lecture du statut.": "CinetPay checkout opened. Verification continues only by reading the status.",
  "Les trois documents Premium sont maintenant disponibles.": "The three Premium documents are now available.",
  "Vérifier/réparer les 3 documents Premium": "Check/repair the 3 Premium documents",
  "Télécharger DOCX": "Download DOCX",
  "← Dashboard": "← Dashboard",
  "FICHES TD": "WORKSHEETS",
  "Créer une fiche de travaux dirigés": "Create a tutorial worksheet",
  "Une leçon, jusqu’à cinq exercices par partie, comme sur le site Quick Learning.": "One lesson, up to five exercises per part, as on the Quick Learning website.",
  "Matière *": "Subject *",
  "Module *": "Module *",
  "Leçon *": "Lesson *",
  "Sans établissement": "No school",
  "Année académique": "Academic year",
  "Style d’en-tête": "Header style",
  "PDF, DOCX et correction": "PDF, DOCX and correction",
  "PDF sujet": "Paper PDF",
  "Sélection des exercices": "Exercise selection",
  "Sans choix manuel, jusqu’à 5 exercices sont sélectionnés automatiquement dans chaque partie.": "Without a manual choice, up to 5 exercises are selected automatically in each part.",
  "Prévisualiser": "Preview",
  "Générer et payer plus tard": "Generate and pay later",
  "Traitement…": "Processing…",
  "Générer maintenant (": "Generate now (",
  "Aperçu protégé": "Protected preview",
  "La fiche finale téléchargée après paiement sera sans filigrane.": "The final worksheet downloaded after payment will have no watermark.",
  "Aperçu de la fiche TD": "Worksheet preview",
  "Résultat": "Result",
  "En attente de paiement": "Awaiting payment",
  "Payer avec le portefeuille (": "Pay with the wallet (",
  "Payer avec CinetPay": "Pay with CinetPay",
  "Mes fiches TD": "My worksheets",
  "Aucune fiche générée.": "No worksheet generated.",
  "Aperçu PDF": "PDF preview",
  "Impossible d’afficher le PDF. Réessayez l’aperçu.": "Unable to display the PDF. Try the preview again.",
  "Impossible de charger l’espace enseignant.": "Unable to load the teacher space.",
  "Impossible de charger les options du générateur.": "Unable to load the generator options.",
  "Paiement": "Payment",
  "Recharge": "Top-up",
  "Réussie": "Successful",
  "Échouée": "Failed",
  "Impossible de charger l’historique du portefeuille.": "Unable to load the wallet history.",
  "Recharge réussie ! Vous avez obtenu un bonus de bienvenue de +100% :": "Top-up successful! You got a +100% welcome bonus:",
  "offerts en plus, pour un total de": "offered in addition, for a total of",
  "La tentative a expiré après 2 minutes. Vous pouvez saisir un nouveau montant.": "The attempt expired after 2 minutes. You can enter a new amount.",
  "Recharge échouée. Aucun montant n'a été crédité.": "Top-up failed. No amount was credited.",
  "Votre session a expiré.": "Your session has expired.",
  "Cette recharge ne vous appartient pas.": "This top-up does not belong to you.",
  "Cette recharge est introuvable.": "This top-up cannot be found.",
  "Le statut de la recharge n’a pas encore pu être confirmé.": "The top-up status could not be confirmed yet.",
  "L’initialisation ne peut pas être rejouée. Vérifiez ultérieurement votre historique.": "The initialisation cannot be replayed. Check your history later.",
  "La recharge a été initialisée sans URL de paiement. Utilisez Actualiser le statut.": "The top-up was initialised without a payment URL. Use Refresh status.",
  "La recharge a été initialisée, mais l’URL CinetPay a été refusée ou n’a pas pu être ouverte. Aucun nouveau POST ne sera envoyé.": "The top-up was initialised, but the CinetPay URL was refused or could not be opened. No new POST will be sent.",
  "Le montant de recharge est invalide.": "The top-up amount is invalid.",
  "Cette recharge n’est pas autorisée.": "This top-up is not allowed.",
  "Une recharge est déjà en cours.": "A top-up is already in progress.",
  "La recharge n’a pas pu être initialisée.": "The top-up could not be initialised.",
  "Le service de recharge est indisponible.": "The top-up service is unavailable.",
  "Le service de paiement est temporairement indisponible.": "The payment service is temporarily unavailable.",
  "Le service de recharge est temporairement indisponible.": "The top-up service is temporarily unavailable.",
  "Vous pouvez réessayer.": "You can try again.",
  "L’initialisation de la recharge a échoué.": "The top-up initialisation failed.",
  "Le résultat de l’initialisation n’a pas pu être confirmé. Aucun nouveau POST ne sera envoyé.": "The initialisation result could not be confirmed. No new POST will be sent.",
  "Finances": "Finances",
  "Solde du portefeuille": "Wallet balance",
  "Solde actuel": "Current balance",
  "Bonus de bienvenue : +100% sur votre 1ère recharge !": "Welcome bonus: +100% on your first top-up!",
  "Rechargez par exemple 500": "For example, top up 500",
  ", votre solde affichera 1000": ", your balance will show 1000",
  "Crédit": "Credit",
  "Recharger le portefeuille": "Top up the wallet",
  "Montant autorisé : de 100 à 2 500 000": "Allowed amount: from 100 to 2,500,000",
  "Recharger": "Top up",
  "Recharge confirmée": "Top-up confirmed",
  "— bonus de bienvenue de": "— welcome bonus of",
  "offert !": "offered!",
  "Le solde et l’historique ont été actualisés.": "The balance and history have been refreshed.",
  "Montant à recharger": "Amount to top up",
  "Saisissez un montant entier entre 100 et 2 500 000": "Enter a whole amount between 100 and 2,500,000",
  "Vérification…": "Checking…",
  "Actualiser le statut": "Refresh status",
  "Abandonner cette tentative": "Abandon this attempt",
  "Recharge en attente de confirmation CinetPay.": "Top-up awaiting CinetPay confirmation.",
  "Confirmer la recharge de": "Confirm the top-up of",
  "Mouvements": "Movements",
  "Historique des transactions": "Transaction history",
  "Filtrer les transactions": "Filter transactions",
  "Paiements": "Payments",
  "Recharges": "Top-ups",
  "Aucune transaction": "No transaction",
  "Les paiements et recharges apparaîtront ici.": "Payments and top-ups will appear here.",
  "Transaction": "Transaction",
  "Épreuve #": "Test #",
  "Pagination du portefeuille": "Wallet pagination",
  "Certains critères sont invalides. Vérifiez votre sélection.": "Some criteria are invalid. Check your selection.",
  "Ce compte n’est pas autorisé à consulter la banque d’exercices.": "This account is not allowed to view the exercise bank.",
  "La ressource demandée est introuvable.": "The requested resource cannot be found.",
  "Le serveur ne peut pas traiter la demande pour le moment.": "The server cannot process the request at the moment.",
  "Le serveur met trop de temps à répondre. Réessayez.": "The server is taking too long to respond. Try again.",
  "Connexion au serveur impossible. Vérifiez votre accès Internet.": "Unable to reach the server. Check your Internet access.",
  "Impossible de charger les exercices.": "Unable to load the exercises.",
  "Impossible d’analyser la couverture.": "Unable to analyse the coverage.",
  "Choisissez d’abord un palier.": "First choose a tier.",
  "Sélectionnez les exercices requis.": "Select the required exercises.",
  "Une couverture verte est requise avant la génération.": "Green coverage is required before generation.",
  "Ajoutez au moins un exercice pour chaque section pédagogique requise.": "Add at least one exercise for each required teaching section.",
  "Remplissez toutes les positions prévues par les règles du site.": "Fill in all the positions required by the website rules.",
  "La génération est momentanément indisponible.": "Generation is temporarily unavailable.",
  "Impossible d’afficher cet aperçu PDF.": "Unable to display this PDF preview.",
  "Étape 3": "Step 3",
  "Sélection intelligente des exercices": "Smart exercise selection",
  "Les résultats proviennent de la banque pédagogique Quick Learning et respectent les critères du compte enseignant.": "The results come from the Quick Learning teaching bank and meet the teacher account's criteria.",
  "Couverture de la banque": "Bank coverage",
  "de couverture": "coverage",
  "sections couvertes": "sections covered",
  "Analyse de la couverture…": "Analysing coverage…",
  "Exercices disponibles": "Available exercises",
  "résultat": "result",
  "Chargement des exercices…": "Loading exercises…",
  "Aucun exercice ne correspond aux critères sélectionnés.": "No exercise matches the selected criteria.",
  "Pagination des exercices": "Exercise pagination",
  "Étape 1": "Step 1",
  "Préparez l’en-tête et le contexte pédagogique de l’épreuve.": "Prepare the header and the teaching context of the test.",
  "Aucun établissement enregistré": "No school recorded",
  "Ajoutez votre établissement directement dans l’application.": "Add your school directly in the app.",
  "Gérer mes établissements": "Manage my schools",
  "Sélectionner un établissement": "Select a school",
  "Sélectionner une classe": "Select a class",
  "Sélectionner une matière": "Select a subject",
  "Session *": "Session *",
  "Sélectionner une session": "Select a session",
  "Durée *": "Duration *",
  "Coefficient": "Coefficient",
  "(optionnel)": "(optional)",
  "Ex : 4": "E.g. 4",
  "Intitulé": "Title",
  "Ex : Évaluation de fin de séquence": "E.g. End-of-sequence assessment",
  "Période / Séquence": "Period / Sequence",
  "Ex : 2": "E.g. 2",
  "Date de l’épreuve": "Test date",
  "Ex : 20/04/2026": "E.g. 20/04/2026",
  "Style d’en-tête *": "Header style *",
  "Choisissez une maquette. Le contenu réel de votre établissement apparaîtra dans la prévisualisation.": "Choose a template. Your school's actual details will appear in the preview.",
  "Palier *": "Tier *",
  "PDF sujet, DOCX et PDF corrigé": "Paper PDF, DOCX and answer key PDF",
  "Aperçu de": "Preview of",
  "Exercice #": "Exercise #",
  "Non classé": "Unclassified",
  "Aucun extrait disponible.": "No excerpt available.",
  "Images": "Images",
  "Schémas": "Diagrams",
  "Filtres des exercices": "Exercise filters",
  "Titre, énoncé ou mot-clé…": "Title, statement or keyword…",
  "Tous les modules choisis": "All chosen modules",
  "Toutes les leçons choisies": "All chosen lessons",
  "Type d’évaluation": "Assessment type",
  "Difficulté": "Difficulty",
  "Niveau / classe": "Level / class",
  "Classe sélectionnée": "Selected class",
  "Non disponible": "Not available",
  "Étape 2": "Step 2",
  "Modules et leçons": "Modules and lessons",
  "Sélectionnez le périmètre du programme utilisé pour la future épreuve.": "Select the scope of the curriculum used for the future test.",
  "Modules *": "Modules *",
  "sélectionné(s)": "selected",
  "Chargement des modules…": "Loading modules…",
  "Aucun module disponible pour cette matière et cette classe.": "No module available for this subject and class.",
  "sélectionnée(s)": "selected",
  "Sélectionnez au moins un module pour afficher ses leçons.": "Select at least one module to show its lessons.",
  "Chargement des leçons…": "Loading lessons…",
  "Aucune leçon n’est associée aux modules sélectionnés.": "No lesson is linked to the selected modules.",
  "La sélection de leçons reste facultative lorsque les modules définissent déjà le périmètre.": "Selecting lessons is optional when the modules already define the scope.",
  "Classique": "Classic",
  "Premium": "Premium",
  "Champ obligatoire manquant": "Required field missing",
  "Sélectionnez une matière.": "Select a subject.",
  "Corriger ce champ": "Correct this field",
  "Palier obligatoire": "Tier required",
  "Choisissez le palier Classique ou Premium avant de confirmer la génération.": "Choose the Classic or Premium tier before confirming the generation.",
  "Choisir un palier": "Choose a tier",
  "Correction Premium indisponible": "Premium correction unavailable",
  "Les corrections sont partielles (3 éléments sur 5). Vous pouvez continuer sans correction au palier Classique (200 FCFA) ou revenir au choix du palier.": "The corrections are partial (3 items out of 5). You can continue without correction at the Classic tier (200 FCFA) or go back to the tier choice.",
  "Changer de palier": "Change tier",
  "Continuer sans correction — 200 FCFA": "Continue without correction — 200 FCFA",
  "Démonstration locale — données synthétiques": "Local demonstration — synthetic data",
  "Prévisualisation réussie": "Preview successful",
  "Le palier apparaît uniquement après vérification de l’aperçu.": "The tier only appears after the preview has been checked.",
  "Choisissez le palier après avoir vérifié l’épreuve *": "Choose the tier after checking the test *",
  "La génération n’a pas abouti": "The generation did not complete",
  "La réponse du serveur n’a pas été reçue. La tentative peut néanmoins avoir abouti.": "The server's response was not received. The attempt may nevertheless have succeeded.",
  "Référence de diagnostic :": "Diagnostic reference:",
  "Vérifier et réessayer avec la même référence": "Check and retry with the same reference",
  "Simuler un champ manquant": "Simulate a missing field",
  "Simuler un échec": "Simulate a failure",
  "Générer l’épreuve": "Generate the test",
  "Toutes vos épreuves": "All your tests",
  "Travail à poursuivre": "Work to continue",
  "Génération en cours": "Generation in progress",
  "Générée": "Generated",
  "Échec de génération": "Generation failed",
  "Impossible de charger vos épreuves.": "Unable to load your tests.",
  "épreuve(s)": "test(s)",
  "Chargement des épreuves…": "Loading tests…",
  "Aucune épreuve": "No test",
  "Aucune épreuve ne correspond à cette vue.": "No test matches this view.",
  "Épreuve sans intitulé": "Untitled test",
  "Palier": "Tier",
  "Génération": "Generation",
  "Non payé": "Unpaid",
  "Documents disponibles": "Documents available",
  "Reprendre": "Resume",
  "Voir le résultat": "See the result",
  "Voir le résultat et payer": "See the result and pay",
  "Pagination des épreuves": "Test pagination",
  "Aperçu PDF protégé": "Protected PDF preview",
  "Préparation de l’aperçu…": "Preparing the preview…",
  "Aperçu PDF de": "PDF preview of",
  "Retirer de l’épreuve": "Remove from the test",
  "Ajouter à l’épreuve": "Add to the test",
  "Étape 4": "Step 4",
  "Prévisualisation fidèle de l’épreuve": "Faithful preview of the test",
  "Ce PDF est produit par le même moteur ReportLab que le document final. Aucune épreuve n’est encore créée.": "This PDF is produced by the same ReportLab engine as the final document. No test has been created yet.",
  "La prévisualisation comporte volontairement plusieurs filigranes de sécurité. Après paiement, vous pourrez télécharger l’épreuve définitive, propre et sans ces filigranes.": "The preview deliberately carries several security watermarks. After payment, you will be able to download the final, clean test without these watermarks.",
  "Préparation de toutes les pages…": "Preparing all the pages…",
  "Prévisualisation PDF de l’épreuve": "PDF preview of the test",
  "Le résultat de la génération n’a pas pu être confirmé.": "The generation result could not be confirmed.",
  "Les informations de l’épreuve sont invalides.": "The test information is invalid.",
  "Ce compte n’est pas autorisé à générer une épreuve.": "This account is not allowed to generate a test.",
  "Cette tentative de génération ne peut pas être relancée dans son état actuel.": "This generation attempt cannot be restarted in its current state.",
  "La génération des documents a échoué.": "Document generation failed.",
  "Le service de génération est temporairement indisponible.": "The generation service is temporarily unavailable.",
  "Impossible de générer l’épreuve.": "Unable to generate the test.",
  "Les paramètres ont changé. Actualisez la prévisualisation avant de confirmer.": "The settings have changed. Refresh the preview before confirming.",
  "Vous n’êtes pas autorisé à consulter cette épreuve.": "You are not allowed to view this test.",
  "Cette épreuve est introuvable.": "This test cannot be found.",
  "Impossible de charger cette épreuve.": "Unable to load this test.",
  "Impossible de charger les modules.": "Unable to load the modules.",
  "Impossible de charger les leçons.": "Unable to load the lessons.",
  "été retiré": "been removed",
  ", car la sélection pédagogique a changé.": ", because the teaching selection changed.",
  "Sélectionnez un établissement.": "Select a school.",
  "Sélectionnez une classe.": "Select a class.",
  "Sélectionnez une session.": "Select a session.",
  "Sélectionnez un palier.": "Select a tier.",
  "La durée est obligatoire.": "The duration is required.",
  "Saisissez un coefficient numérique positif.": "Enter a positive numeric coefficient.",
  "Sélectionnez au moins un module.": "Select at least one module.",
  "Sélection obligatoire": "Selection required",
  "Choisir un module": "Choose a module",
  "Sélectionnez au moins un exercice.": "Select at least one exercise.",
  "Choisir un exercice": "Choose an exercise",
  "Toutes les positions prévues par le site pour ce type d’exercice sont déjà remplies.": "All the positions required by the website for this type of exercise are already filled.",
  "La Situation 2 attend un exercice à situation unique (8 pts). Cet exercice de 16 pts doit occuper la Situation 1.": "Situation 2 expects a single-situation exercise (8 pts). This 16-pt exercise must take Situation 1.",
  "Cet exercice de compétences contient déjà deux situations (16 pts) : la Situation 2 n’est plus nécessaire.": "This skills exercise already contains two situations (16 pts): Situation 2 is no longer needed.",
  "Impossible de produire l’aperçu fidèle de l’épreuve.": "Unable to produce the faithful preview of the test.",
  "déjà en cours": "already in progress",
  "Les corrections sont partielles (": "The corrections are partial (",
  "élément": "item",
  "Aucune correction n’est disponible pour les exercices sélectionnés.": "No correction is available for the selected exercises.",
  "La disponibilité des corrections n’a pas pu être confirmée avec cette version des données.": "The availability of corrections could not be confirmed with this version of the data.",
  "Vous pouvez continuer sans correction au palier Classique (": "You can continue without correction at the Classic tier (",
  ") ou revenir au choix du palier.": ") or go back to the tier choice.",
  "Le prix du palier sans correction n’est pas disponible. Revenez au choix du palier.": "The price of the tier without correction is not available. Go back to the tier choice.",
  "Continuer sans correction —": "Continue without correction —",
  "Continuer sans correction — tarif indisponible": "Continue without correction — price unavailable",
  "Saisissez un identifiant numérique valide.": "Enter a valid numeric identifier.",
  "Épreuve introuvable.": "Test not found.",
  "La demande de paiement est invalide.": "The payment request is invalid.",
  "Ce paiement n’est pas autorisé.": "This payment is not allowed.",
  "Une tentative de paiement CinetPay est déjà en cours pour cette épreuve.": "A CinetPay payment attempt is already in progress for this test.",
  "Solde insuffisant pour effectuer ce paiement.": "Insufficient balance to make this payment.",
  "Le résultat du paiement n’a pas pu être confirmé.": "The payment result could not be confirmed.",
  "Le résultat du paiement n’a pas pu être confirmé. Vérifiez votre connexion puis réessayez.": "The payment result could not be confirmed. Check your connection and try again.",
  "Le paiement n’a pas pu être effectué.": "The payment could not be made.",
  "Le paiement n’a pas abouti.": "The payment did not go through.",
  "La tentative de paiement a expiré.": "The payment attempt has expired.",
  "Le paiement a été annulé.": "The payment was cancelled.",
  "Aucune tentative CinetPay active n’a été retrouvée.": "No active CinetPay attempt was found.",
  "Le statut du paiement n’a pas encore pu être confirmé.": "The payment status could not be confirmed yet.",
  "Le paiement a été initialisé, mais l’ouverture de la page CinetPay a échoué. Utilisez uniquement l’actualisation du statut.": "The payment was initialised, but opening the CinetPay page failed. Only use the status refresh.",
  "Le paiement CinetPay est temporairement indisponible.": "CinetPay payment is temporarily unavailable.",
  "Chargement du générateur…": "Loading the generator…",
  "Options indisponibles": "Options unavailable",
  "Retour au dashboard": "Back to the dashboard",
  "Résultat de la génération": "Generation result",
  "Reprendre une épreuve existante": "Resume an existing test",
  "Identifiant de l’épreuve": "Test identifier",
  "Ex. 252": "E.g. 252",
  "Programme": "Curriculum",
  "Synthèse": "Summary",
  "Document DOCX": "DOCX document",
  "PDF corrigé": "Answer key PDF",
  "Génération terminée": "Generation complete",
  "Épreuve générée avec succès": "Test generated",
  "Paiement effectué avec succès": "Payment successful",
  "Paiement requis pour télécharger les documents.": "Payment required to download the documents.",
  "Numéro": "Number",
  "Solde disponible": "Available balance",
  "Montant à payer": "Amount to pay",
  "Payer avec mon portefeuille": "Pay with my wallet",
  "Initialisation…": "Initialising…",
  "Paiement CinetPay en cours…": "CinetPay payment in progress…",
  "Confirmer le paiement de": "Confirm the payment of",
  "avec votre portefeuille ?": "with your wallet?",
  "Vous allez être redirigé vers CinetPay pour effectuer le paiement de": "You will be redirected to CinetPay to make the payment of",
  "Paiement CinetPay effectué avec succès.": "CinetPay payment successful.",
  "Paiement CinetPay en attente de confirmation.": "CinetPay payment awaiting confirmation.",
  "Le statut de l’initialisation n’a pas encore pu être confirmé.": "The initialisation status could not be confirmed yet.",
  "Documents générés": "Generated documents",
  "Généré": "Generated",
  "Non disponible avec ce palier": "Not available with this tier",
  "Paiement requis": "Payment required",
  "Document indisponible": "Document unavailable",
  "Indisponible": "Unavailable",
  "Créer une nouvelle épreuve": "Create a new test",
  "Sélection réelle": "Actual selection",
  "Épreuve en préparation": "Test in preparation",
  "Ajoutez des exercices depuis le catalogue.": "Add exercises from the catalogue.",
  "Glisser pour réordonner": "Drag to reorder",
  "Points non renseignés": "Points not provided",
  "Monter": "Move up",
  "Descendre": "Move down",
  "Points disponibles": "Points available",
  "Sans points": "No points",
  "Réessayer avec la même clé": "Retry with the same key",
  "Certaines informations de l’épreuve sont invalides.": "Some test information is invalid.",
  "Corriger les informations": "Correct the information",
  "Votre compte ne permet pas cette génération. Contactez l’assistance si cette situation est inattendue.": "Your account does not allow this generation. Contact support if this is unexpected.",
  "Contacter l’assistance": "Contact support",
  "Cette génération est déjà en cours. Vous pouvez vérifier son résultat sans créer une nouvelle tentative.": "This generation is already in progress. You can check its result without creating a new attempt.",
  "Vérifier avec la même référence": "Check with the same reference",
  "Réessayer avec la même référence": "Retry with the same reference",
  "Le serveur n’a pas pu produire les documents.": "The server could not produce the documents.",
  "Une erreur inattendue a empêché la génération.": "An unexpected error prevented the generation.",
  "Impossible de charger votre compte.": "Unable to load your account.",
  "Vos informations ont été mises à jour.": "Your details have been updated.",
  "Impossible de mettre à jour votre profil.": "Unable to update your profile.",
  "Renseignez le mot de passe actuel et le nouveau mot de passe.": "Enter the current password and the new password.",
  "Les deux nouveaux mots de passe ne correspondent pas.": "The two new passwords do not match.",
  "Mot de passe modifié. Votre session reste active.": "Password changed. Your session remains active.",
  "Impossible de modifier le mot de passe.": "Unable to change the password.",
  "Chargement de votre compte…": "Loading your account…",
  "Compte indisponible": "Account unavailable",
  "Retour au Dashboard": "Back to the dashboard",
  "Compte utilisateur": "User account",
  "Mon profil": "My profile",
  "Gérez vos informations et la sécurité de votre compte sans quitter l’application.": "Manage your details and your account security without leaving the app.",
  "Avatar du profil": "Profile avatar",
  "Choisir une photo": "Choose a photo",
  "Informations générateur": "Generator information",
  "Non attribué": "Not assigned",
  "Aucune matière associée": "No subject linked",
  "Sécurité": "Security",
  "La politique de sécurité est vérifiée par le serveur.": "The security policy is checked by the server.",
  "Modification…": "Changing…",
  "Impossible de charger vos notifications.": "Unable to load your notifications.",
  "non lue": "unread",
  "Toutes vos notifications sont lues.": "All your notifications are read.",
  "Les nouvelles informations apparaîtront ici.": "New information will appear here.",
  "Liste des notifications": "List of notifications",
  "Lue": "Read",
  "Non lue": "Unread",
};

export default EN_ESPACES;
